import React, { FunctionComponent } from 'react'
import loadable from '@loadable/component'
import { LoadableComponent } from '@loadable/component'
import { LoadPanel } from 'devextreme-react/load-panel'
import pMinDelay from 'p-min-delay'

const Fallback = () => (<LoadPanel visible={ true } />)

const IxAccountStatement: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/account-statement/account-statement'), 500), {
    resolveComponent: (imported: any) => imported.IxAccountStatement,
    fallback: (<Fallback />),
})
const IxAuftragHinweisPage: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/auftrag-hinweis.gen/auftrag-hinweis-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxAuftragHinweisPage,
    fallback: (<Fallback />),
})
const IxAuftragPrioPage: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/auftrag-prio.gen/auftrag-prio-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxAuftragPrioPage,
    fallback: (<Fallback />),
})
const IxAuftragTerminModulePage: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/auftrag-termin.gen/auftrag-termin-module-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxAuftragTerminModulePage,
    fallback: (<Fallback />),
})
const IxAuftragPage: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/auftrag.gen/auftrag-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxAuftragPage,
    fallback: (<Fallback />),
})
const IxAuftragsArtKlassePage: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/auftrags-art-klasse.gen/auftrags-art-klasse-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxAuftragsArtKlassePage,
    fallback: (<Fallback />),
})
const IxAuftragsArtPage: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/auftrags-art.gen/auftrags-art-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxAuftragsArtPage,
    fallback: (<Fallback />),
})
const IxAuftragsStatusArtPage: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/auftrags-status-art.gen/auftrags-status-art-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxAuftragsStatusArtPage,
    fallback: (<Fallback />),
})
const IxBackgroundJobs: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/background-jobs'), 500), {
    resolveComponent: (imported: any) => imported.IxBackgroundJobs,
    fallback: (<Fallback />),
})
const IxBuDimTestPage: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/bu-dim.gen/bu-dim-test-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxBuDimTestPage,
    fallback: (<Fallback />),
})
const ContractManagement: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/contract-management'), 500), {
    resolveComponent: (imported: any) => imported.ContractManagement,
    fallback: (<Fallback />),
})
const ContractManagementV2: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/contract-management-v2'), 500), {
    resolveComponent: (imported: any) => imported.ContractManagementV2,
    fallback: (<Fallback />),
})
const Contracts: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/contracts'), 500), {
    resolveComponent: (imported: any) => imported.Contracts,
    fallback: (<Fallback />),
})
const ContractsAdd: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/contracts-add'), 500), {
    resolveComponent: (imported: any) => imported.ContractsAdd,
    fallback: (<Fallback />),
})
const IxGenehmigungDefinitionPage: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/genehmigungs-definition.gen/genehmigung-definition-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxGenehmigungDefinitionPage,
    fallback: (<Fallback />),
})
const IxGwMaengelStatusPage: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/gw-maengel-status.gen/gw-maengel-status-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxGwMaengelStatusPage,
    fallback: (<Fallback />),
})
const IxGwSicherungsArtPage: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/gw-sicherungs-art.gen/gw-sicherungs-art-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxGwSicherungsArtPage,
    fallback: (<Fallback />),
})
const IxGwSicherungsStatusPage: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/gw-sicherungs-status.gen/gw-sicherungs-status-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxGwSicherungsStatusPage,
    fallback: (<Fallback />),
})
const Home: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/home'), 500), {
    resolveComponent: (imported: any) => imported.Home,
    fallback: (<Fallback />),
})
const IssuesAdd: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/issues-add'), 500), {
    resolveComponent: (imported: any) => imported.IssuesAdd,
    fallback: (<Fallback />),
})
const IssuesDb: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/issues-db'), 500), {
    resolveComponent: (imported: any) => imported.IssuesDb,
    fallback: (<Fallback />),
})
const Ix1000Page: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/ix-1000.gen/1000-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.Ix1000Page,
    fallback: (<Fallback />),
})
const IxProcess1010Page: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/ix-1010.gen/process-1010-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxProcess1010Page,
    fallback: (<Fallback />),
})
const IxReport1022Page: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/ix-1022.gen/report-1022-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxReport1022Page,
    fallback: (<Fallback />),
})
const IxUmlPage: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/ix-1033.gen/uml-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxUmlPage,
    fallback: (<Fallback />),
})
const IxAAPage: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/ix-1060.gen/aa-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxAAPage,
    fallback: (<Fallback />),
})
const IxFlartPage: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/ix-1070.gen/flart-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxFlartPage,
    fallback: (<Fallback />),
})
const IxFlstmPage: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/ix-1071.gen/flstm-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxFlstmPage,
    fallback: (<Fallback />),
})
const Ix1072Page: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/ix-1072.gen/1072-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.Ix1072Page,
    fallback: (<Fallback />),
})
const IxProcess107211Page: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/ix-107211.gen/process-107211-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxProcess107211Page,
    fallback: (<Fallback />),
})
const IxErlSchm200010BuPage: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/ix-200010bu.gen/erl-schm-200010-bu-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxErlSchm200010BuPage,
    fallback: (<Fallback />),
})
const IxReport200084Page: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/ix-20008.gen/report-200084-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxReport200084Page,
    fallback: (<Fallback />),
})
const IxSollstellungPage: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/ix-20008.gen/sollstellung-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxSollstellungPage,
    fallback: (<Fallback />),
})
const IxSollstellungSimulationPage: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/ix-20008sim.gen/sollstellung-simulation-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxSollstellungSimulationPage,
    fallback: (<Fallback />),
})
const Ix2000biPage: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/ix-2000bi.gen/2000bi-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.Ix2000biPage,
    fallback: (<Fallback />),
})
const Ix20011Page: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/ix-20011.gen/20011-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.Ix20011Page,
    fallback: (<Fallback />),
})
const IxProcess2011Page: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/ix-2011.gen/process-2011-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxProcess2011Page,
    fallback: (<Fallback />),
})
const IxProcess2013Page: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/ix-2013.gen/process-2013-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxProcess2013Page,
    fallback: (<Fallback />),
})
const IxProcess2014Page: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/ix-2014.gen/process-2014-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxProcess2014Page,
    fallback: (<Fallback />),
})
const IxProcess202001Page: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/ix-202001.gen/process-202001-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxProcess202001Page,
    fallback: (<Fallback />),
})
const Ix2031Page: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/ix-2031.gen/2031-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.Ix2031Page,
    fallback: (<Fallback />),
})
const Ix2044Page: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/ix-2044.gen/2044-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.Ix2044Page,
    fallback: (<Fallback />),
})
const Ix2048Page: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/ix-2048.gen/2048-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.Ix2048Page,
    fallback: (<Fallback />),
})
const IxMahndatenPage: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/ix-2050.gen/mahndaten-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxMahndatenPage,
    fallback: (<Fallback />),
})
const Ix2060Page: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/ix-2060.gen/2060-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.Ix2060Page,
    fallback: (<Fallback />),
})
const Ix2067Page: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/ix-2067.gen/2067-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.Ix2067Page,
    fallback: (<Fallback />),
})
const Ix2076Page: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/ix-2076.gen/2076-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.Ix2076Page,
    fallback: (<Fallback />),
})
const IxProcess3010ParamPage: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/ix-3010.gen/process-3010-param-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxProcess3010ParamPage,
    fallback: (<Fallback />),
})
const IxProcess3025Page: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/ix-3025.gen/process-3025-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxProcess3025Page,
    fallback: (<Fallback />),
})
const IxProcess3026Page: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/ix-3026.gen/process-3026-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxProcess3026Page,
    fallback: (<Fallback />),
})
const IxAbrKartePage: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/ix-30571ak.gen/abr-karte-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxAbrKartePage,
    fallback: (<Fallback />),
})
const IxProcess404050ParamPage: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/ix-404050.gen/process-404050-param-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxProcess404050ParamPage,
    fallback: (<Fallback />),
})
const IxProcess6020BerechnungPage: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/ix-6020.gen/process-6020-berechnung-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxProcess6020BerechnungPage,
    fallback: (<Fallback />),
})
const IxProcess6020ListePage: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/ix-6022.gen/process-6020-liste-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxProcess6020ListePage,
    fallback: (<Fallback />),
})
const IxProcess6020BuchenPage: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/ix-6023.gen/process-6020-buchen-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxProcess6020BuchenPage,
    fallback: (<Fallback />),
})
const IxOwnPage: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/ix-web-owner.gen/own-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxOwnPage,
    fallback: (<Fallback />),
})
const IxPrnsrvcPage: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/ix-web-prnsrvc.gen/prnsrvc-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxPrnsrvcPage,
    fallback: (<Fallback />),
})
const IxGruppenDbPage: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/ixadmin.gen/gruppen-db-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxGruppenDbPage,
    fallback: (<Fallback />),
})
const IxBtKreisPage: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/ixbetkreis.gen/bt-kreis-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxBtKreisPage,
    fallback: (<Fallback />),
})
const IxProcessDatevParamPage: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/ixdatevex.gen/process-datev-param-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxProcessDatevParamPage,
    fallback: (<Fallback />),
})
const IxReportParERechnungReadyPage: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/ixerechnungready.gen/report-par-e-rechnung-ready-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxReportParERechnungReadyPage,
    fallback: (<Fallback />),
})
const IxProcessIxHansaInvestStdBuExportPage: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/ixhansainveststdbuexp.gen/process-hansa-invest-std-bu-export-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxProcessIxHansaInvestStdBuExportPage,
    fallback: (<Fallback />),
})
const IxProcessHypothekReportParamPage: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/ixhypothekreport.gen/process-hypothek-report-param-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxProcessHypothekReportParamPage,
    fallback: (<Fallback />),
})
const IxProcessIntrealParamPage: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/ixintrealsapbuexp.gen/process-intreal-param-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxProcessIntrealParamPage,
    fallback: (<Fallback />),
})
const IxObjPage: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/ixobject.gen/obj-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxObjPage,
    fallback: (<Fallback />),
})
const IxKtgDimTestPage: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/ktg-dim.gen/ktg-dim-test-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxKtgDimTestPage,
    fallback: (<Fallback />),
})
const IxProcessKx0224SapBuExportPage: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/kx-0224sapbuexp.gen/process-kx-0224-sap-bu-export-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxProcessKx0224SapBuExportPage,
    fallback: (<Fallback />),
})
const IxProcessBisonBoxExportPage: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/kxbisonbox.gen/process-bison-box-export-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxProcessBisonBoxExportPage,
    fallback: (<Fallback />),
})
const IxProcessKxBnpSapBuExportPage: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/kxbnpsapbuexp.gen/process-kx-bnp-sap-bu-export-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxProcessKxBnpSapBuExportPage,
    fallback: (<Fallback />),
})
const IxProcessKxBuUserInfoExportPage: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/kxbuuserinfoexp.gen/process-kx-bu-user-info-export-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxProcessKxBuUserInfoExportPage,
    fallback: (<Fallback />),
})
const IxProcessPrinterSetupParamInterfacePage: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/kxineprintersetupexe.gen/process-printer-setup-param-interface-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxProcessPrinterSetupParamInterfacePage,
    fallback: (<Fallback />),
})
const IxProcessTrassetsExportPage: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/kxtrassetsexp.gen/process-trassets-export-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxProcessTrassetsExportPage,
    fallback: (<Fallback />),
})
const IxProcessTrinityExportPage: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/kxtrinitybuexp.gen/process-trinity-export-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxProcessTrinityExportPage,
    fallback: (<Fallback />),
})
const IxLeistungsArtPage: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/leistungs-art.gen/leistungs-art-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxLeistungsArtPage,
    fallback: (<Fallback />),
})
const IxLeistungsVerzeichnisPage: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/leistungs-verzeichnis.gen/leistungs-verzeichnis-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxLeistungsVerzeichnisPage,
    fallback: (<Fallback />),
})
const IxLieferBedingungPage: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/liefer-bedingung.gen/liefer-bedingung-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxLieferBedingungPage,
    fallback: (<Fallback />),
})
const IxProcess1001Page: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/lx-1001.gen/process-1001-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxProcess1001Page,
    fallback: (<Fallback />),
})
const IxProcess1003Page: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/lx-1003.gen/process-1003-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxProcess1003Page,
    fallback: (<Fallback />),
})
const IxProcess1005Page: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/lx-1005.gen/process-1005-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxProcess1005Page,
    fallback: (<Fallback />),
})
const IxProcess1006Page: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/lx-1006.gen/process-1006-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxProcess1006Page,
    fallback: (<Fallback />),
})
const IxProcess101002ParamPage: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/lx-101002.gen/process-101002-param-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxProcess101002ParamPage,
    fallback: (<Fallback />),
})
const IxProcess101003Page: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/lx-101003.gen/process-101003-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxProcess101003Page,
    fallback: (<Fallback />),
})
const IxProcess102001Page: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/lx-102001.gen/process-102001-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxProcess102001Page,
    fallback: (<Fallback />),
})
const IxProcess102002Page: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/lx-102002.gen/process-102002-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxProcess102002Page,
    fallback: (<Fallback />),
})
const IxProcess102003Page: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/lx-102003.gen/process-102003-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxProcess102003Page,
    fallback: (<Fallback />),
})
const IxProcess1021ParamPage: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/lx-1021.gen/process-1021-param-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxProcess1021ParamPage,
    fallback: (<Fallback />),
})
const IxProcess103002Page: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/lx-103002.gen/process-103002-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxProcess103002Page,
    fallback: (<Fallback />),
})
const IxProcess1040Page: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/lx-1040.gen/process-1040-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxProcess1040Page,
    fallback: (<Fallback />),
})
const IxProcess1061Page: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/lx-1061.gen/process-1061-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxProcess1061Page,
    fallback: (<Fallback />),
})
const IxProcess107049Page: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/lx-107049.gen/process-107049-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxProcess107049Page,
    fallback: (<Fallback />),
})
const IxProcess107050Page: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/lx-107050.gen/process-107050-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxProcess107050Page,
    fallback: (<Fallback />),
})
const IxProcess107055Page: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/lx-107055.gen/process-107055-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxProcess107055Page,
    fallback: (<Fallback />),
})
const IxProcess107101Page: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/lx-107101.gen/process-107101-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxProcess107101Page,
    fallback: (<Fallback />),
})
const IxProcess107102Page: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/lx-107102.gen/process-107102-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxProcess107102Page,
    fallback: (<Fallback />),
})
const IxProcess107103Page: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/lx-107103.gen/process-107103-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxProcess107103Page,
    fallback: (<Fallback />),
})
const IxProcess107104Page: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/lx-107104.gen/process-107104-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxProcess107104Page,
    fallback: (<Fallback />),
})
const IxProcess1071041Page: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/lx-1071041.gen/process-1071041-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxProcess1071041Page,
    fallback: (<Fallback />),
})
const IxProcess107105Page: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/lx-107105.gen/process-107105-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxProcess107105Page,
    fallback: (<Fallback />),
})
const IxReport107106Page: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/lx-107106.gen/report-107106-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxReport107106Page,
    fallback: (<Fallback />),
})
const IxProcess107108Page: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/lx-107108.gen/process-107108-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxProcess107108Page,
    fallback: (<Fallback />),
})
const IxProcess107109Page: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/lx-107109.gen/process-107109-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxProcess107109Page,
    fallback: (<Fallback />),
})
const IxProcess107110Page: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/lx-107110.gen/process-107110-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxProcess107110Page,
    fallback: (<Fallback />),
})
const IxProcess107113Page: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/lx-107113.gen/process-107113-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxProcess107113Page,
    fallback: (<Fallback />),
})
const IxProcess107115Page: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/lx-107115.gen/process-107115-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxProcess107115Page,
    fallback: (<Fallback />),
})
const IxProcess107120Page: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/lx-107120.gen/process-107120-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxProcess107120Page,
    fallback: (<Fallback />),
})
const IxProcess107122Page: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/lx-107122.gen/process-107122-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxProcess107122Page,
    fallback: (<Fallback />),
})
const IxProcess107123Page: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/lx-107123.gen/process-107123-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxProcess107123Page,
    fallback: (<Fallback />),
})
const IxProcess107128Page: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/lx-107128.gen/process-107128-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxProcess107128Page,
    fallback: (<Fallback />),
})
const IxProcess107129Page: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/lx-107129.gen/process-107129-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxProcess107129Page,
    fallback: (<Fallback />),
})
const IxProcess107135Page: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/lx-107135.gen/process-107135-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxProcess107135Page,
    fallback: (<Fallback />),
})
const IxProcess107232Page: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/lx-107232.gen/process-107232-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxProcess107232Page,
    fallback: (<Fallback />),
})
const IxProcess1082Page: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/lx-1082.gen/process-1082-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxProcess1082Page,
    fallback: (<Fallback />),
})
const IxProcess1084Page: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/lx-1084.gen/process-1084-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxProcess1084Page,
    fallback: (<Fallback />),
})
const IxProcess1086Page: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/lx-1086.gen/process-1086-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxProcess1086Page,
    fallback: (<Fallback />),
})
const IxProcess1090Page: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/lx-1090.gen/process-1090-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxProcess1090Page,
    fallback: (<Fallback />),
})
const IxProcess109041Page: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/lx-109041.gen/process-109041-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxProcess109041Page,
    fallback: (<Fallback />),
})
const IxProcess11722Page: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/lx-11722.gen/process-11722-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxProcess11722Page,
    fallback: (<Fallback />),
})
const IxProcess11725Page: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/lx-11725.gen/process-11725-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxProcess11725Page,
    fallback: (<Fallback />),
})
const IxProcess1230051Page: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/lx-1230051.gen/process-1230051-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxProcess1230051Page,
    fallback: (<Fallback />),
})
const IxProcess1230053Page: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/lx-1230053.gen/process-1230053-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxProcess1230053Page,
    fallback: (<Fallback />),
})
const IxProcess123010Page: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/lx-123010.gen/process-123010-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxProcess123010Page,
    fallback: (<Fallback />),
})
const IxProcess200010Page: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/lx-200010.gen/process-200010-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxProcess200010Page,
    fallback: (<Fallback />),
})
const IxReport200085Page: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/lx-200085.gen/report-200085-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxReport200085Page,
    fallback: (<Fallback />),
})
const IxProcess200101Page: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/lx-200101.gen/process-200101-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxProcess200101Page,
    fallback: (<Fallback />),
})
const IxProcess200105Page: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/lx-200105.gen/process-200105-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxProcess200105Page,
    fallback: (<Fallback />),
})
const IxProcess200109Page: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/lx-200109.gen/process-200109-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxProcess200109Page,
    fallback: (<Fallback />),
})
const IxProcess200120Page: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/lx-200120.gen/process-200120-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxProcess200120Page,
    fallback: (<Fallback />),
})
const IxProcess200140Page: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/lx-200140.gen/process-200140-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxProcess200140Page,
    fallback: (<Fallback />),
})
const IxProcess2003Page: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/lx-2003.gen/process-2003-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxProcess2003Page,
    fallback: (<Fallback />),
})
const IxProcess201004Page: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/lx-201004.gen/process-201004-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxProcess201004Page,
    fallback: (<Fallback />),
})
const IxReport201051Page: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/lx-201051.gen/report-201051-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxReport201051Page,
    fallback: (<Fallback />),
})
const IxProcess201052Page: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/lx-201052.gen/process-201052-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxProcess201052Page,
    fallback: (<Fallback />),
})
const IxProcess2016Page: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/lx-2016.gen/process-2016-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxProcess2016Page,
    fallback: (<Fallback />),
})
const IxProcess2025Page: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/lx-2025.gen/process-2025-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxProcess2025Page,
    fallback: (<Fallback />),
})
const IxProcess2031Page: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/lx-2031.gen/process-2031-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxProcess2031Page,
    fallback: (<Fallback />),
})
const IxProcess2035ParamPage: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/lx-2035.gen/process-2035-param-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxProcess2035ParamPage,
    fallback: (<Fallback />),
})
const IxProcess204005Page: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/lx-204005.gen/process-204005-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxProcess204005Page,
    fallback: (<Fallback />),
})
const IxProcess204006Page: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/lx-204006.gen/process-204006-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxProcess204006Page,
    fallback: (<Fallback />),
})
const IxProcess20401Page: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/lx-20401.gen/process-20401-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxProcess20401Page,
    fallback: (<Fallback />),
})
const IxProcess204031Page: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/lx-204031.gen/process-204031-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxProcess204031Page,
    fallback: (<Fallback />),
})
const IxProcess204402Page: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/lx-204402.gen/process-204402-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxProcess204402Page,
    fallback: (<Fallback />),
})
const IxProcess2049ParamPage: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/lx-2049.gen/process-2049-param-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxProcess2049ParamPage,
    fallback: (<Fallback />),
})
const IxProcess2051Page: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/lx-2051.gen/process-2051-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxProcess2051Page,
    fallback: (<Fallback />),
})
const IxProcess2052Page: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/lx-2052.gen/process-2052-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxProcess2052Page,
    fallback: (<Fallback />),
})
const IxProcess2053Page: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/lx-2053.gen/process-2053-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxProcess2053Page,
    fallback: (<Fallback />),
})
const IxProcess2072Page: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/lx-2072.gen/process-2072-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxProcess2072Page,
    fallback: (<Fallback />),
})
const IxProcess2073ParamPage: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/lx-2073.gen/process-2073-param-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxProcess2073ParamPage,
    fallback: (<Fallback />),
})
const IxProcess2074Page: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/lx-2074.gen/process-2074-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxProcess2074Page,
    fallback: (<Fallback />),
})
const IxProcess2075Page: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/lx-2075.gen/process-2075-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxProcess2075Page,
    fallback: (<Fallback />),
})
const IxProcess2076Page: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/lx-2076.gen/process-2076-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxProcess2076Page,
    fallback: (<Fallback />),
})
const IxProcess211101Page: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/lx-211101.gen/process-211101-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxProcess211101Page,
    fallback: (<Fallback />),
})
const IxProcess2113Page: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/lx-2113.gen/process-2113-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxProcess2113Page,
    fallback: (<Fallback />),
})
const IxProcess2123Page: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/lx-2123.gen/process-2123-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxProcess2123Page,
    fallback: (<Fallback />),
})
const IxProcess2124Page: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/lx-2124.gen/process-2124-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxProcess2124Page,
    fallback: (<Fallback />),
})
const IxProcess22001Page: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/lx-22001.gen/process-22001-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxProcess22001Page,
    fallback: (<Fallback />),
})
const IxProcess22002Page: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/lx-22002.gen/process-22002-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxProcess22002Page,
    fallback: (<Fallback />),
})
const IxProcess2300ParamPage: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/lx-2300.gen/process-2300-param-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxProcess2300ParamPage,
    fallback: (<Fallback />),
})
const IxProcess240001Page: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/lx-240001.gen/process-240001-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxProcess240001Page,
    fallback: (<Fallback />),
})
const IxReport2400KtoAuszugPage: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/lx-240002.gen/report-2400-kto-auszug-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxReport2400KtoAuszugPage,
    fallback: (<Fallback />),
})
const IxProcess240001ProDruckVglPage: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/lx-240004.gen/process-240001-pro-druck-vgl-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxProcess240001ProDruckVglPage,
    fallback: (<Fallback />),
})
const IxProcess240007ParamPage: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/lx-240007.gen/process-240007-param-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxProcess240007ParamPage,
    fallback: (<Fallback />),
})
const IxProcess304002Page: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/lx-304002.gen/process-304002-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxProcess304002Page,
    fallback: (<Fallback />),
})
const IxProcess304003Page: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/lx-304003.gen/process-304003-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxProcess304003Page,
    fallback: (<Fallback />),
})
const IxProcess304004Page: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/lx-304004.gen/process-304004-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxProcess304004Page,
    fallback: (<Fallback />),
})
const IxProcess304005Page: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/lx-304005.gen/process-304005-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxProcess304005Page,
    fallback: (<Fallback />),
})
const IxProcess304006Page: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/lx-304006.gen/process-304006-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxProcess304006Page,
    fallback: (<Fallback />),
})
const IxProcess304007Page: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/lx-304007.gen/process-304007-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxProcess304007Page,
    fallback: (<Fallback />),
})
const IxProcess304011Page: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/lx-304011.gen/process-304011-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxProcess304011Page,
    fallback: (<Fallback />),
})
const IxProcess304012Page: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/lx-304012.gen/process-304012-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxProcess304012Page,
    fallback: (<Fallback />),
})
const IxProcess404002Page: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/lx-404002.gen/process-404002-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxProcess404002Page,
    fallback: (<Fallback />),
})
const IxProcess404011Page: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/lx-404011.gen/process-404011-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxProcess404011Page,
    fallback: (<Fallback />),
})
const IxProcess404051ParamPage: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/lx-404051.gen/process-404051-param-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxProcess404051ParamPage,
    fallback: (<Fallback />),
})
const IxProcess404052ParamPage: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/lx-404052.gen/process-404052-param-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxProcess404052ParamPage,
    fallback: (<Fallback />),
})
const IxProcess404053ParamPage: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/lx-404053.gen/process-404053-param-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxProcess404053ParamPage,
    fallback: (<Fallback />),
})
const IxProcess40600Page: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/lx-40600.gen/process-40600-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxProcess40600Page,
    fallback: (<Fallback />),
})
const IxProcess40604Page: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/lx-40604.gen/process-40604-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxProcess40604Page,
    fallback: (<Fallback />),
})
const IxProcess40606Page: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/lx-40606.gen/process-40606-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxProcess40606Page,
    fallback: (<Fallback />),
})
const IxMeldungHinweis3Page: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/meldung-hinweis-3.gen/meldung-hinweis-3-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxMeldungHinweis3Page,
    fallback: (<Fallback />),
})
const IxMeldungHinweisPage: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/meldung-hinweis.gen/meldung-hinweis-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxMeldungHinweisPage,
    fallback: (<Fallback />),
})
const IxMeldungPrioPage: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/meldung-prio.gen/meldung-prio-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxMeldungPrioPage,
    fallback: (<Fallback />),
})
const IxMeldungStatusArtPage: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/meldung-status-art.gen/meldung-status-art-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxMeldungStatusArtPage,
    fallback: (<Fallback />),
})
const IxMeldungVersFallGwrkPage: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/meldung-vers-fall-gwrk.gen/meldung-vers-fall-gwrk-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxMeldungVersFallGwrkPage,
    fallback: (<Fallback />),
})
const IxMeldungVersFallPage: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/meldung-vers-fall.gen/meldung-vers-fall-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxMeldungVersFallPage,
    fallback: (<Fallback />),
})
const IxMeldungPage: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/meldung.gen/meldung-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxMeldungPage,
    fallback: (<Fallback />),
})
const IxMeldungsArtKlassePage: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/meldungs-art-klasse.gen/meldungs-art-klasse-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxMeldungsArtKlassePage,
    fallback: (<Fallback />),
})
const IxMeldungsArtPage: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/meldungs-art.gen/meldungs-art-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxMeldungsArtPage,
    fallback: (<Fallback />),
})
const IxJobPage: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/protokoll.gen/job-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxJobPage,
    fallback: (<Fallback />),
})
const Setting: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/settings'), 500), {
    resolveComponent: (imported: any) => imported.Setting,
    fallback: (<Fallback />),
})
const IxTODefPage: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/to-def.gen/to-def-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxTODefPage,
    fallback: (<Fallback />),
})
const IxTOGesundheitsamtPage: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/to-gesundheitsamt.gen/to-gesundheitsamt-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxTOGesundheitsamtPage,
    fallback: (<Fallback />),
})
const IxTOHerstellerPage: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/to-hersteller.gen/to-hersteller-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxTOHerstellerPage,
    fallback: (<Fallback />),
})
const IxTOPruefungsartPage: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/to-pruefungsart.gen/to-pruefungsart-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxTOPruefungsartPage,
    fallback: (<Fallback />),
})
const IxTORechtsgrundlagenPage: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/to-rechtsgrundlagen.gen/to-rechtsgrundlagen-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxTORechtsgrundlagenPage,
    fallback: (<Fallback />),
})
const IxTOPage: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/to.gen/to-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxTOPage,
    fallback: (<Fallback />),
})
const IxXspgetzlgtlrzPage: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/xspgetzlgtlrz.gen/xspgetzlgtlrz-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxXspgetzlgtlrzPage,
    fallback: (<Fallback />),
})
const IxZahlungsBedingungPage: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('pages/zahlungs-bedingung.gen/zahlungs-bedingung-page.gen'), 500), {
    resolveComponent: (imported: any) => imported.IxZahlungsBedingungPage,
    fallback: (<Fallback />),
})
const IxAccountLookupForm: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('test-pages/account-lookup-form'), 500), {
    resolveComponent: (imported: any) => imported.IxAccountLookupForm,
    fallback: (<Fallback />),
})
const Benchmark: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('test-pages/benchmark'), 500), {
    resolveComponent: (imported: any) => imported.Benchmark,
    fallback: (<Fallback />),
})
const Charts: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('test-pages/charts'), 500), {
    resolveComponent: (imported: any) => imported.Charts,
    fallback: (<Fallback />),
})
const ChartsQLik: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('test-pages/charts-qlik'), 500), {
    resolveComponent: (imported: any) => imported.ChartsQLik,
    fallback: (<Fallback />),
})
const IxClearing: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('test-pages/clearing'), 500), {
    resolveComponent: (imported: any) => imported.IxClearing,
    fallback: (<Fallback />),
})
const GeneratedBenchmark: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('test-pages/generated-benchmark'), 500), {
    resolveComponent: (imported: any) => imported.GeneratedBenchmark,
    fallback: (<Fallback />),
})
const Inactive: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('test-pages/inactive'), 500), {
    resolveComponent: (imported: any) => imported.Inactive,
    fallback: (<Fallback />),
})
const Issues: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('test-pages/issues'), 500), {
    resolveComponent: (imported: any) => imported.Issues,
    fallback: (<Fallback />),
})
const IssuesFormik: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('test-pages/issues-formik'), 500), {
    resolveComponent: (imported: any) => imported.IssuesFormik,
    fallback: (<Fallback />),
})
const IssuesNew: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('test-pages/issues-new'), 500), {
    resolveComponent: (imported: any) => imported.IssuesNew,
    fallback: (<Fallback />),
})
const IxLookupTestPage: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('test-pages/lookup-test'), 500), {
    resolveComponent: (imported: any) => imported.IxLookupTestPage,
    fallback: (<Fallback />),
})
const IxTestForm: LoadableComponent<FunctionComponent> = loadable(() => pMinDelay(import('test-pages/test-form'), 500), {
    resolveComponent: (imported: any) => imported.IxTestForm,
    fallback: (<Fallback />),
})

const t = (x: string) => x

interface IIxNavData {
    text: string,
    path: string,
    fullPath?: string,
    qParams?: string,
    icon: string,
    favorite: boolean,
    items?: IIxNavData[],
    prg?: string,
    parent_path?: string,
    parent_path_prg?: string,
    type?: string,
    name?: string,
    name_en?: string,
}

export interface IIxNavItem {
    text: string,
    icon: string,
    path: string,
    fullPath?: string,
    items?: IIxNavItem[],
    badge?: string | number,
    expanded?: boolean,
    favorite?: boolean,
    prg?: string,
    parent_path?: string,
    parent_path_prg?: string,
    type?: string,
    name?: string,
    name_en?: string,
}

export interface IIxRoute {
    path: string,
    component: FunctionComponent | LoadableComponent<any>,
    prg?: string,
}


const routes: IIxRoute[] = [
    {
        path: '/issues/add',
        component: IssuesAdd,
        prg: '',
    },
    {
        path: '/issues/db',
        component: IssuesDb,
        prg: '',
    },
    {
        path: '/issues/new',
        component: IssuesNew,
        prg: '',
    },
    {
        path: '/issues/archive',
        component: IssuesFormik,
        prg: '',
    },
    {
        path: '/issues',
        component: Issues,
        prg: '',
    },
    {
        path: '/benchmark',
        component: Benchmark,
        prg: '',
    },
    {
        path: '/genbenchmark',
        component: GeneratedBenchmark,
        prg: '',
    },
    {
        path: '/charts',
        component: Charts,
        prg: '',
    },
    {
        path: '/chartsQLik',
        component: ChartsQLik,
        prg: '',
    },
    {
        path: '/contracts',
        component: Contracts,
        prg: '',
    },
    {
        path: '/contractsadd',
        component: ContractsAdd,
        prg: '',
    },
    {
        path: '/contract-management',
        component: ContractManagement,
        prg: '',
    },
    {
        path: '/contract-management-v2',
        component: ContractManagementV2,
        prg: '',
    },
    {
        path: '/ix1072',
        component: Ix1072Page,
        prg: 'C_IX1072',
    },
    {
        path: '/test-form',
        component: IxTestForm,
        prg: '',
    },
    {
        path: '/lookup-test',
        component: IxLookupTestPage,
        prg: '',
    },
    {
        path: '/account-lookup-form',
        component: IxAccountLookupForm,
        prg: '',
    },
    {
        path: '/settings',
        component: Setting,
        prg: 'C_IXSYSTEMALLGEMEIN',
    },
    {
        path: '/background-jobs',
        component: IxBackgroundJobs,
        prg: '',
    },
    {
        path: '/jobs-page',
        component: IxJobPage,
        prg: 'C_NO_MODULE_PUT_TO_ITEMSWITHOUTMENU_FOLDER',
    },
    {
        path: '/clearing',
        component: IxClearing,
        prg: '',
    },
    {
        path: '/ix2010',
        component: IxAccountStatement,
        prg: 'C_IX2010',
    },
    {
        path: '/lx201051',
        component: IxReport201051Page,
        prg: 'C_LX201051',
    },
    {
        path: '/lx107106',
        component: IxReport107106Page,
        prg: 'C_LX107106',
    },
    {
        path: '/lx240002',
        component: IxReport2400KtoAuszugPage,
        prg: 'C_LX240002',
    },
    {
        path: '/xspgetzlgtlrz-page',
        component: IxXspgetzlgtlrzPage,
        prg: 'C_LX20011',
    },
    {
        path: '/budim-test-page',
        component: IxBuDimTestPage,
        prg: '',
    },
    {
        path: '/ktgdim-test-page',
        component: IxKtgDimTestPage,
        prg: '',
    },
    {
        path: '/ix2048',
        component: Ix2048Page,
        prg: 'C_IX2048',
    },
    {
        path: '/ix1010',
        component: IxProcess1010Page,
        prg: 'C_IX1010',
    },
    {
        path: '/ix1060',
        component: IxAAPage,
        prg: 'C_IX1060',
    },
    {
        path: '/ix200010bu',
        component: IxErlSchm200010BuPage,
        prg: 'C_IX200010BU',
    },
    {
        path: '/lx200084',
        component: IxReport200084Page,
        prg: 'C_NO_MODULE_PUT_TO_ITEMSWITHOUTMENU_FOLDER',
    },
    {
        path: '/lx200085',
        component: IxReport200085Page,
        prg: 'C_NO_MODULE_PUT_TO_ITEMSWITHOUTMENU_FOLDER',
    },
    {
        path: '/ixWebOwner',
        component: IxOwnPage,
        prg: 'C_NO_MODULE_PUT_TO_ITEMSWITHOUTMENU_FOLDER',
    },
    {
        path: '/inactive',
        component: Inactive,
        prg: 'A_INACTIVE',
    },
    {
        path: '/ix2000bi',
        component: Ix2000biPage,
        prg: 'C_IX2000BI',
    },
    {
        path: '/lx11725',
        component: IxProcess11725Page,
        prg: 'C_NO_MODULE_PUT_TO_ITEMSWITHOUTMENU_FOLDER',
    },
    {
        path: '/ix2013',
        component: IxProcess2013Page,
        prg: 'C_IX2013',
    },
    {
        path: '/ix2014',
        component: IxProcess2014Page,
        prg: 'C_IX2014',
    },
    {
        path: '/lx2051',
        component: IxProcess2051Page,
        prg: 'C_NO_MODULE_PUT_TO_ITEMSWITHOUTMENU_FOLDER',
    },
    {
        path: '/ixerechnungready',
        component: IxReportParERechnungReadyPage,
        prg: 'C_NO_MODULE_PUT_TO_ITEMSWITHOUTMENU_FOLDER',
    },
    {
        path: '/MeldungVersFall',
        component: IxMeldungVersFallPage,
        prg: 'C_..\\NURIS\\NCREM.NURIS.MELDUNGVERSFALL',
    },
    {
        path: '/MeldungVersFallGwrk',
        component: IxMeldungVersFallGwrkPage,
        prg: 'C_..\\NURIS\\NCREM.NURIS.MELDUNGVERSFALLGWRK',
    },
    {
        path: '/ix20011',
        component: Ix20011Page,
        prg: 'C_IX20011',
    },
    {
        path: '/ix2076',
        component: Ix2076Page,
        prg: 'C_IX2076',
    },
    {
        path: '/Meldung',
        component: IxMeldungPage,
        prg: 'C_..\\NURIS\\NCREM.NURIS.MELDUNG',
    },
    {
        path: '/ixobject',
        component: IxObjPage,
        prg: 'C_IXOBJECT',
    },
    {
        path: '/ix2044',
        component: Ix2044Page,
        prg: 'C_IX2044',
    },
    {
        path: '/ix1000',
        component: Ix1000Page,
        prg: 'C_IX1000',
    },
    {
        path: '/ix1070',
        component: IxFlartPage,
        prg: 'C_IX1070',
    },
    {
        path: '/ixadmin',
        component: IxGruppenDbPage,
        prg: 'C/IXADMIN',
    },
    {
        path: '/ix1071',
        component: IxFlstmPage,
        prg: 'C_IX1071',
    },
    {
        path: '/ixbetkreis',
        component: IxBtKreisPage,
        prg: 'C_IXBETKREIS',
    },
    {
        path: '/ix20008',
        component: IxSollstellungPage,
        prg: 'C_IX20008',
    },
    {
        path: '/lx107108',
        component: IxProcess107108Page,
        prg: 'C_LX107108',
    },
    {
        path: '/lx107129',
        component: IxProcess107129Page,
        prg: 'C_LX107129',
    },
    {
        path: '/lx200105',
        component: IxProcess200105Page,
        prg: 'C_LX200105',
    },
    {
        path: '/lx404053',
        component: IxProcess404053ParamPage,
        prg: 'C_LX404053',
    },
    {
        path: '/ix3010',
        component: IxProcess3010ParamPage,
        prg: 'C_IX3010',
    },
    {
        path: '/lx2074',
        component: IxProcess2074Page,
        prg: 'C_LX2074',
    },
    {
        path: '/lx2076',
        component: IxProcess2076Page,
        prg: 'C_LX2076',
    },
    {
        path: '/lx1021',
        component: IxProcess1021ParamPage,
        prg: 'C_LX1021',
    },
    {
        path: '/lx103002',
        component: IxProcess103002Page,
        prg: 'C_LX103002',
    },
    {
        path: '/lx2072',
        component: IxProcess2072Page,
        prg: 'C_LX2072',
    },
    {
        path: '/lx1001',
        component: IxProcess1001Page,
        prg: 'C_LX1001',
    },
    {
        path: '/lx107113',
        component: IxProcess107113Page,
        prg: 'C_LX107113',
    },
    {
        path: '/lx2300',
        component: IxProcess2300ParamPage,
        prg: 'C_LX2300',
    },
    {
        path: '/lx2073',
        component: IxProcess2073ParamPage,
        prg: 'C_LX2073',
    },
    {
        path: '/lx2003',
        component: IxProcess2003Page,
        prg: 'C_LX2003',
    },
    {
        path: '/lx2075',
        component: IxProcess2075Page,
        prg: 'C_LX2075',
    },
    {
        path: '/lx101002',
        component: IxProcess101002ParamPage,
        prg: 'C_LX101002',
    },
    {
        path: '/lx1061',
        component: IxProcess1061Page,
        prg: 'C_LX1061',
    },
    {
        path: '/ix404050',
        component: IxProcess404050ParamPage,
        prg: 'C_IX404050',
    },
    {
        path: '/ix202001',
        component: IxProcess202001Page,
        prg: 'C_IX202001',
    },
    {
        path: '/lx404051',
        component: IxProcess404051ParamPage,
        prg: 'C_LX404051',
    },
    {
        path: '/lx107123',
        component: IxProcess107123Page,
        prg: 'C_LX107123',
    },
    {
        path: '/lx107055',
        component: IxProcess107055Page,
        prg: 'C_LX107055',
    },
    {
        path: '/lx404052',
        component: IxProcess404052ParamPage,
        prg: 'C_LX404052',
    },
    {
        path: '/lx40604',
        component: IxProcess40604Page,
        prg: 'C_LX40604',
    },
    {
        path: '/lx107109',
        component: IxProcess107109Page,
        prg: 'C_LX107109',
    },
    {
        path: '/lx107049',
        component: IxProcess107049Page,
        prg: 'C_LX107049',
    },
    {
        path: '/lx40606',
        component: IxProcess40606Page,
        prg: 'C_LX40606',
    },
    {
        path: '/ix1022',
        component: IxReport1022Page,
        prg: 'C_IX1022',
    },
    {
        path: '/MeldungHinweis',
        component: IxMeldungHinweisPage,
        prg: 'C_..\\NURIS\\NCREM.NURIS.MELDUNGHINWEIS',
    },
    {
        path: '/MeldungHinweis3',
        component: IxMeldungHinweis3Page,
        prg: 'C_..\\NURIS\\NCREM.NURIS.MELDUNGHINWEIS3',
    },
    {
        path: '/MeldungPrio',
        component: IxMeldungPrioPage,
        prg: 'C_..\\NURIS\\NCREM.NURIS.MELDUNGPRIO',
    },
    {
        path: '/MeldungsArt',
        component: IxMeldungsArtPage,
        prg: 'C_..\\NURIS\\NCREM.NURIS.MELDUNGSART',
    },
    {
        path: '/MeldungsArtKlasse',
        component: IxMeldungsArtKlassePage,
        prg: 'C_..\\NURIS\\NCREM.NURIS.MELDUNGSARTKLASSE',
    },
    {
        path: '/MeldungStatusArt',
        component: IxMeldungStatusArtPage,
        prg: 'C_..\\NURIS\\NCREM.NURIS.MELDUNGSTATUSART',
    },
    {
        path: '/lx107135',
        component: IxProcess107135Page,
        prg: 'C_LX107135',
    },
    {
        path: '/lx200101',
        component: IxProcess200101Page,
        prg: 'C_LX200101',
    },
    {
        path: '/lx200109',
        component: IxProcess200109Page,
        prg: 'C_LX200109',
    },
    {
        path: '/lx200140',
        component: IxProcess200140Page,
        prg: 'C_LX200140',
    },
    {
        path: '/lx201004',
        component: IxProcess201004Page,
        prg: 'C_LX201004',
    },
    {
        path: '/lx2031',
        component: IxProcess2031Page,
        prg: 'C_LX2031',
    },
    {
        path: '/lx204031',
        component: IxProcess204031Page,
        prg: 'C_LX204031',
    },
    {
        path: '/ix20008sim',
        component: IxSollstellungSimulationPage,
        prg: 'C_IX20008SIM',
    },
    {
        path: '/ix1033',
        component: IxUmlPage,
        prg: 'C_IX1033',
    },
    {
        path: '/AuftragPrio',
        component: IxAuftragPrioPage,
        prg: 'C_..\\NURIS\\NCREM.NURIS.AUFTRAG\\AUFTRAGPRIO',
    },
    {
        path: '/AuftragsArtKlasse',
        component: IxAuftragsArtKlassePage,
        prg: 'C_..\\NURIS\\NCREM.NURIS.AUFTRAG\\AUFTRAGSARTKLASSE',
    },
    {
        path: '/GwMaengelStatus',
        component: IxGwMaengelStatusPage,
        prg: 'C_..\\NURIS\\NCREM.NURIS.AUFTRAG\\GWMAENGELSTATUS',
    },
    {
        path: '/GwSicherungsArt',
        component: IxGwSicherungsArtPage,
        prg: 'C_..\\NURIS\\NCREM.NURIS.AUFTRAG\\GWSICHERUNGSART',
    },
    {
        path: '/GwSicherungsStatus',
        component: IxGwSicherungsStatusPage,
        prg: 'C_..\\NURIS\\NCREM.NURIS.AUFTRAG\\GWSICHERUNGSSTATUS',
    },
    {
        path: '/AuftragsArt',
        component: IxAuftragsArtPage,
        prg: 'C_..\\NURIS\\NCREM.NURIS.AUFTRAG\\AUFTRAGSART',
    },
    {
        path: '/AuftragsStatusArt',
        component: IxAuftragsStatusArtPage,
        prg: 'C_..\\NURIS\\NCREM.NURIS.AUFTRAG\\AUFTRAGSSTATUSART',
    },
    {
        path: '/GenehmigungsDefinition',
        component: IxGenehmigungDefinitionPage,
        prg: 'C_..\\NURIS\\NCREM.NURIS.AUFTRAG\\GENEHMIGUNGSDEFINITION',
    },
    {
        path: '/Auftrag',
        component: IxAuftragPage,
        prg: 'C_..\\NURIS\\NCREM.NURIS.AUFTRAG',
    },
    {
        path: '/AuftragTermin',
        component: IxAuftragTerminModulePage,
        prg: 'C_..\\NURIS\\NCREM.NURIS.AUFTRAGTERMIN',
    },
    {
        path: '/LeistungsArt',
        component: IxLeistungsArtPage,
        prg: 'C_..\\NURIS\\NCREM.NURIS.AUFTRAG\\LEISTUNGSART',
    },
    {
        path: '/LeistungsVerzeichnis',
        component: IxLeistungsVerzeichnisPage,
        prg: 'C_..\\NURIS\\NCREM.NURIS.AUFTRAG\\LEISTUNGSVERZEICHNIS',
    },
    {
        path: '/LieferBedingung',
        component: IxLieferBedingungPage,
        prg: 'C_..\\NURIS\\NCREM.NURIS.AUFTRAG\\LIEFERBEDINGUNG',
    },
    {
        path: '/ZahlungsBedingung',
        component: IxZahlungsBedingungPage,
        prg: 'C_..\\NURIS\\NCREM.NURIS.AUFTRAG\\ZAHLUNGSBEDINGUNG',
    },
    {
        path: '/AuftragHinweis',
        component: IxAuftragHinweisPage,
        prg: 'C_..\\NURIS\\NCREM.NURIS.AUFTRAG\\AUFTRAGHINWEIS',
    },
    {
        path: '/ixWebPrnsrvc',
        component: IxPrnsrvcPage,
        prg: 'C_IXWEBPRNSRVC',
    },
    {
        path: '/ix2060',
        component: Ix2060Page,
        prg: 'C_IX2060',
    },
    {
        path: '/ix2067',
        component: Ix2067Page,
        prg: 'C_IX2067',
    },
    {
        path: '/lx1003',
        component: IxProcess1003Page,
        prg: 'C_LX1003',
    },
    {
        path: '/lx1005',
        component: IxProcess1005Page,
        prg: 'C_LX1005',
    },
    {
        path: '/lx102001',
        component: IxProcess102001Page,
        prg: 'C_LX102001',
    },
    {
        path: '/lx102003',
        component: IxProcess102003Page,
        prg: 'C_LX102003',
    },
    {
        path: '/lx1040',
        component: IxProcess1040Page,
        prg: 'C_LX1040',
    },
    {
        path: '/lx107050',
        component: IxProcess107050Page,
        prg: 'C_LX107050',
    },
    {
        path: '/lx107101',
        component: IxProcess107101Page,
        prg: 'C_LX107101',
    },
    {
        path: '/lx107102',
        component: IxProcess107102Page,
        prg: 'C_LX107102',
    },
    {
        path: '/lx107103',
        component: IxProcess107103Page,
        prg: 'C_LX107103',
    },
    {
        path: '/lx107128',
        component: IxProcess107128Page,
        prg: 'C_LX107128',
    },
    {
        path: '/lx11722',
        component: IxProcess11722Page,
        prg: 'C_LX11722',
    },
    {
        path: '/lx200120',
        component: IxProcess200120Page,
        prg: 'C_LX200120',
    },
    {
        path: '/ix2011',
        component: IxProcess2011Page,
        prg: 'C_IX2011',
    },
    {
        path: '/lx102002',
        component: IxProcess102002Page,
        prg: 'C_LX102002',
    },
    {
        path: '/lx1230051',
        component: IxProcess1230051Page,
        prg: 'C_LX1230051',
    },
    {
        path: '/lx1230053',
        component: IxProcess1230053Page,
        prg: 'C_LX1230053',
    },
    {
        path: '/lx123010',
        component: IxProcess123010Page,
        prg: 'C_LX123010',
    },
    {
        path: '/lx201052',
        component: IxProcess201052Page,
        prg: 'C_LX201052',
    },
    {
        path: '/lx2016',
        component: IxProcess2016Page,
        prg: 'C_LX2016',
    },
    {
        path: '/lx2025',
        component: IxProcess2025Page,
        prg: 'C_LX2025',
    },
    {
        path: '/lx2035',
        component: IxProcess2035ParamPage,
        prg: 'C_LX2035',
    },
    {
        path: '/lx204005',
        component: IxProcess204005Page,
        prg: 'C_LX204005',
    },
    {
        path: '/lx204006',
        component: IxProcess204006Page,
        prg: 'C_LX204006',
    },
    {
        path: '/lx204402',
        component: IxProcess204402Page,
        prg: 'C_LX204402',
    },
    {
        path: '/lx2049',
        component: IxProcess2049ParamPage,
        prg: 'C_LX2049',
    },
    {
        path: '/lx211101',
        component: IxProcess211101Page,
        prg: 'C_LX211101',
    },
    {
        path: '/lx2113',
        component: IxProcess2113Page,
        prg: 'C_LX2113',
    },
    {
        path: '/lx2123',
        component: IxProcess2123Page,
        prg: 'C_LX2123',
    },
    {
        path: '/lx2124',
        component: IxProcess2124Page,
        prg: 'C_LX2124',
    },
    {
        path: '/lx240001',
        component: IxProcess240001Page,
        prg: 'C_LX240001',
    },
    {
        path: '/lx240007',
        component: IxProcess240007ParamPage,
        prg: 'C_LX240007',
    },
    {
        path: '/ixdatevex',
        component: IxProcessDatevParamPage,
        prg: 'C_IXDATEVEX',
    },
    {
        path: '/process-printer',
        component: IxProcessPrinterSetupParamInterfacePage,
        prg: '',
    },
    {
        path: '/lx107104',
        component: IxProcess107104Page,
        prg: 'C_LX107104',
    },
    {
        path: '/lx107105',
        component: IxProcess107105Page,
        prg: 'C_LX107105',
    },
    {
        path: '/lx107110',
        component: IxProcess107110Page,
        prg: 'C_LX107110',
    },
    {
        path: '/lx107115',
        component: IxProcess107115Page,
        prg: 'C_LX107115',
    },
    {
        path: '/lx107232',
        component: IxProcess107232Page,
        prg: 'C_LX107232',
    },
    {
        path: '/lx1090',
        component: IxProcess1090Page,
        prg: 'C_LX1090',
    },
    {
        path: '/lx2052',
        component: IxProcess2052Page,
        prg: 'C_LX2052',
    },
    {
        path: '/lx2053',
        component: IxProcess2053Page,
        prg: 'C_LX2053',
    },
    {
        path: '/lx22001',
        component: IxProcess22001Page,
        prg: 'C_LX22001',
    },
    {
        path: '/lx22002',
        component: IxProcess22002Page,
        prg: 'C_LX22002',
    },
    {
        path: '/lx240004',
        component: IxProcess240001ProDruckVglPage,
        prg: 'C_LX240004',
    },
    {
        path: '/lx404002',
        component: IxProcess404002Page,
        prg: 'C_LX404002',
    },
    {
        path: '/lx404011',
        component: IxProcess404011Page,
        prg: 'C_LX404011',
    },
    {
        path: '/ixhypothekreport',
        component: IxProcessHypothekReportParamPage,
        prg: 'C_IXHYPOTHEKREPORT',
    },
    {
        path: '/ixintrealsapbuexp',
        component: IxProcessIntrealParamPage,
        prg: 'C_IXINTREALSAPBUEXP',
    },
    {
        path: '/ix30571ak',
        component: IxAbrKartePage,
        prg: 'C_IX30571AK',
    },
    {
        path: '/lx1006',
        component: IxProcess1006Page,
        prg: 'C_LX1006',
    },
    {
        path: '/lx101003',
        component: IxProcess101003Page,
        prg: 'C_LX101003',
    },
    {
        path: '/lx1071041',
        component: IxProcess1071041Page,
        prg: 'C_LX1071041',
    },
    {
        path: '/lx107120',
        component: IxProcess107120Page,
        prg: 'C_LX107120',
    },
    {
        path: '/lx107122',
        component: IxProcess107122Page,
        prg: 'C_LX107122',
    },
    {
        path: '/ix107211',
        component: IxProcess107211Page,
        prg: 'C_IX107211',
    },
    {
        path: '/lx1082',
        component: IxProcess1082Page,
        prg: 'C_LX1082',
    },
    {
        path: '/lx109041',
        component: IxProcess109041Page,
        prg: 'C_LX109041',
    },
    {
        path: '/lx200010',
        component: IxProcess200010Page,
        prg: 'C_LX200010',
    },
    {
        path: '/lx20401',
        component: IxProcess20401Page,
        prg: 'C_LX20401',
    },
    {
        path: '/ix3025',
        component: IxProcess3025Page,
        prg: 'C_IX3025',
    },
    {
        path: '/ix3026',
        component: IxProcess3026Page,
        prg: 'C_IX3026',
    },
    {
        path: '/lx304002',
        component: IxProcess304002Page,
        prg: 'C_LX304002',
    },
    {
        path: '/lx304003',
        component: IxProcess304003Page,
        prg: 'C_LX304003',
    },
    {
        path: '/lx304004',
        component: IxProcess304004Page,
        prg: 'C_LX304004',
    },
    {
        path: '/lx304005',
        component: IxProcess304005Page,
        prg: 'C_LX304005',
    },
    {
        path: '/lx304006',
        component: IxProcess304006Page,
        prg: 'C_LX304006',
    },
    {
        path: '/lx304007',
        component: IxProcess304007Page,
        prg: 'C_LX304007',
    },
    {
        path: '/lx304011',
        component: IxProcess304011Page,
        prg: 'C_LX304011',
    },
    {
        path: '/lx304012',
        component: IxProcess304012Page,
        prg: 'C_LX304012',
    },
    {
        path: '/lx40600',
        component: IxProcess40600Page,
        prg: 'C_LX40600',
    },
    {
        path: '/ix6020',
        component: IxProcess6020BerechnungPage,
        prg: 'C_IX6020',
    },
    {
        path: '/ix2031',
        component: Ix2031Page,
        prg: 'C_IX2031',
    },
    {
        path: '/TOGesundheitsamt',
        component: IxTOGesundheitsamtPage,
        prg: 'C_..\\NURIS\\NCREM.NURIS.TO\\TOGESUNDHEITSAMT',
    },
    {
        path: '/TOHersteller',
        component: IxTOHerstellerPage,
        prg: 'C_..\\NURIS\\NCREM.NURIS.TO\\TOHERSTELLER',
    },
    {
        path: '/TORechtsgrundlagen',
        component: IxTORechtsgrundlagenPage,
        prg: 'C_..\\NURIS\\NCREM.NURIS.TO\\TORECHTSGRUNDLAGEN',
    },
    {
        path: '/TO',
        component: IxTOPage,
        prg: 'C_..\\NURIS\\NCREM.NURIS.TO',
    },
    {
        path: '/TODef',
        component: IxTODefPage,
        prg: 'C_..\\NURIS\\NCREM.NURIS.TO\\TODEF',
    },
    {
        path: '/TOPruefungsart',
        component: IxTOPruefungsartPage,
        prg: 'C_..\\NURIS\\NCREM.NURIS.TO\\TOPRUEFUNGSART',
    },
    {
        path: '/ix2050',
        component: IxMahndatenPage,
        prg: 'C_IX2050',
    },
    {
        path: '/lx1084',
        component: IxProcess1084Page,
        prg: 'C_LX1084',
    },
    {
        path: '/lx1086',
        component: IxProcess1086Page,
        prg: 'C_LX1086',
    },
    {
        path: '/ix6023',
        component: IxProcess6020BuchenPage,
        prg: 'C_IX6023',
    },
    {
        path: '/ix6022',
        component: IxProcess6020ListePage,
        prg: 'C_IX6022',
    },
    {
        path: '/kxtrinitybuexp',
        component: IxProcessTrinityExportPage,
        prg: 'C_KXTRINITYBUEXP',
    },
    {
        path: '/kxtrassetsexp',
        component: IxProcessTrassetsExportPage,
        prg: 'C_KXTRASSETSEXP',
    },
    {
        path: '/kxbisonbox',
        component: IxProcessBisonBoxExportPage,
        prg: 'C_KXBISONBOX',
    },
    {
        path: '/ixhansainveststdbuexp',
        component: IxProcessIxHansaInvestStdBuExportPage,
        prg: 'C_IXHANSAINVESTSTDBUEXP',
    },
    {
        path: '/kx0224sapbuexp',
        component: IxProcessKx0224SapBuExportPage,
        prg: 'C_KX0224SAPBUEXP',
    },
    {
        path: '/kxbnpsapbuexp',
        component: IxProcessKxBnpSapBuExportPage,
        prg: 'C_KXBNPSAPBUEXP',
    },
    {
        path: '/kxbuuserinfoexp',
        component: IxProcessKxBuUserInfoExportPage,
        prg: 'C_KXBUUSERINFOEXP',
    },
    {
        path: '/',
        component: Home,
        prg: '',
    },
]

const titles: { [k: string]: string } = {
    '/issues/add': t('drawer-menu:issueAdd'),
    '/issues/db': t('drawer-menu:issuesGrid'),
    '/issues/new': t('drawer-menu:newIssueDevextreme'),
    '/issues/archive': t('drawer-menu:newIssueFormik'),
    '/issues': t('drawer-menu:issues'),
    '/benchmark': t('drawer-menu:benchmarkDatagrid'),
    '/genbenchmark': t('drawer-menu:benchmarkGenerated'),
    '/charts': t('drawer-menu:charts'),
    '/chartsQLik': t('drawer-menu:chartsQLik'),
    '/contracts': t('drawer-menu:contracts'),
    '/contractsadd': t('drawer-menu:contractsAdd'),
    '/contract-management': t('drawer-menu:contractManagement'),
    '/contract-management-v2': t('drawer-menu:contractManagementV2'),
    '/ix1072': t('contract:name.page'),
    '/test-form': t('drawer-menu:testForm'),
    '/lookup-test': t('drawer-menu:lookupTestPage'),
    '/account-lookup-form': t('drawer-menu:accountLookupForm'),
    '/settings': t('drawer-menu:settings'),
    '/background-jobs': t('drawer-menu:backgroundJobs'),
    '/jobs-page': t('bg-jobs:name.page'),
    '/clearing': t('drawer-menu:clearing'),
    '/ix2010': t('global:label.accountStatement.page'),
    '/lx201051': t('report201051:name.page'),
    '/lx107106': t('report107106:name.page'),
    '/lx240002': t('report2400ktoauszug:name.page'),
    '/xspgetzlgtlrz-page': t('xspgetzlgtlrz:name.page'),
    '/budim-test-page': t('buDim:name.page'),
    '/ktgdim-test-page': t('ktgDim:name.page'),
    '/ix2048': t('2048:name.page'),
    '/ix1010': t('process1010:name.page'),
    '/ix1060': t('aa:name.page'),
    '/ix200010bu': t('erlschm200010bu:name.page'),
    '/lx200084': t('report200084:name.page'),
    '/lx200085': t('report200085:name.page'),
    '/ixWebOwner': t('own:name.page'),
    '/inactive': t('global:PageInWork'),
    '/ix2000bi': t('2000bi:name.page'),
    '/lx11725': t('process11725:name.page'),
    '/ix2013': t('process2013:name.page'),
    '/ix2014': t('process2014:name.page'),
    '/lx2051': t('process2051:name.page'),
    '/ixerechnungready': t('reportparerechnungready:name.page'),
    '/MeldungVersFall': t('meldungversfall:label.meldungversfallPage'),
    '/MeldungVersFallGwrk': t('meldungversfallgwrk:label.meldungversfallgwrkPage'),
    '/ix20011': t('20011:name.page'),
    '/ix2076': t('2076:name.page'),
    '/Meldung': t('meldung:name.page'),
    '/ixobject': t('obj:name.page'),
    '/ix2044': t('2044:name.page'),
    '/ix1000': t('per:name.page'),
    '/ix1070': t('flart:name.page'),
    '/ixadmin': t('gruppendb:name.page'),
    '/ix1071': t('flstm:name.page'),
    '/ixbetkreis': t('btkreis:name.page'),
    '/ix20008': t('sollstellung:name.page'),
    '/lx107108': t('process107108:name.page'),
    '/lx107129': t('process107129:name.page'),
    '/lx200105': t('process200105:name.page'),
    '/lx404053': t('process404053param:name.page'),
    '/ix3010': t('process3010param:name.page'),
    '/lx2074': t('process2074:name.page'),
    '/lx2076': t('process2076:name.page'),
    '/lx1021': t('process1021param:name.page'),
    '/lx103002': t('process103002:name.page'),
    '/lx2072': t('process2072:name.page'),
    '/lx1001': t('process1001:name.page'),
    '/lx107113': t('process107113:name.page'),
    '/lx2300': t('process2300param:name.page'),
    '/lx2073': t('process2073param:name.page'),
    '/lx2003': t('process2003:name.page'),
    '/lx2075': t('process2075:name.page'),
    '/lx101002': t('process101002param:name.page'),
    '/lx1061': t('process1061:name.page'),
    '/ix404050': t('process404050param:name.page'),
    '/ix202001': t('process202001:name.page'),
    '/lx404051': t('process404051param:name.page'),
    '/lx107123': t('process107123:name.page'),
    '/lx107055': t('process107055:name.page'),
    '/lx404052': t('process404052param:name.page'),
    '/lx40604': t('process40604:name.page'),
    '/lx107109': t('process107109:name.page'),
    '/lx107049': t('process107049:name.page'),
    '/lx40606': t('process40606:name.page'),
    '/ix1022': t('report1022:name.page'),
    '/MeldungHinweis': t('meldunghinweis:label.meldungHinweisPage'),
    '/MeldungHinweis3': t('meldunghinweis3:label.meldungHinweis3Page'),
    '/MeldungPrio': t('meldungprio:label.meldungPrioPage'),
    '/MeldungsArt': t('meldungsart:label.meldungsArtPage'),
    '/MeldungsArtKlasse': t('meldungsartklasse:label.meldungsArtKlassePage'),
    '/MeldungStatusArt': t('meldungstatusart:label.meldungStatusArtPage'),
    '/lx107135': t('process107135:name.page'),
    '/lx200101': t('process200101:name.page'),
    '/lx200109': t('process200109:name.page'),
    '/lx200140': t('process200140:name.page'),
    '/lx201004': t('process201004:name.page'),
    '/lx2031': t('process2031:name.page'),
    '/lx204031': t('process204031:name.page'),
    '/ix20008sim': t('sollstellungsimulation:name.page'),
    '/ix1033': t('uml:name.page'),
    '/AuftragPrio': t('auftragprio:label.auftragPrioPage'),
    '/AuftragsArtKlasse': t('auftragsartklasse:label.auftragsArtKlassePage'),
    '/GwMaengelStatus': t('gwmaengelstatus:label.gwMaengelStatusPage'),
    '/GwSicherungsArt': t('gwsicherungsart:label.gwSicherungsArtPage'),
    '/GwSicherungsStatus': t('gwsicherungsstatus:label.gwSicherungsStatusPage'),
    '/AuftragsArt': t('auftragsart:label.auftragsArtPage'),
    '/AuftragsStatusArt': t('auftragsstatusart:label.auftragsStatusArtPage'),
    '/GenehmigungsDefinition': t('genehmigungdefinition:label.genehmigungDefinitionPage'),
    '/Auftrag': t('auftrag:label.auftragPage'),
    '/AuftragTermin': t('auftragtermin:label.auftragterminPage'),
    '/LeistungsArt': t('leistungsart:label.leistungsArtPage'),
    '/LeistungsVerzeichnis': t('leistungsverzeichnis:label.leistungsVerzeichnisPage'),
    '/LieferBedingung': t('lieferbedingung:label.lieferBedingungPage'),
    '/ZahlungsBedingung': t('zahlungsbedingung:label.zahlungsBedingungPage'),
    '/AuftragHinweis': t('auftraghinweis:label.auftragHinweisPage'),
    '/ixWebPrnsrvc': t('prnsrvc:name.page'),
    '/ix2060': t('2060:name.page'),
    '/ix2067': t('2067:name.page'),
    '/lx1003': t('process1003:name.page'),
    '/lx1005': t('process1005:name.page'),
    '/lx102001': t('process102001:name.page'),
    '/lx102003': t('process102003:name.page'),
    '/lx1040': t('process1040:name.page'),
    '/lx107050': t('process107050:name.page'),
    '/lx107101': t('process107101:name.page'),
    '/lx107102': t('process107102:name.page'),
    '/lx107103': t('process107103:name.page'),
    '/lx107128': t('process107128:name.page'),
    '/lx11722': t('process11722:name.page'),
    '/lx200120': t('process200120:name.page'),
    '/ix2011': t('process2011:name.page'),
    '/lx102002': t('process102002:name.page'),
    '/lx1230051': t('process1230051:name.page'),
    '/lx1230053': t('process1230053:name.page'),
    '/lx123010': t('process123010:name.page'),
    '/lx201052': t('process201052:name.page'),
    '/lx2016': t('process2016:name.page'),
    '/lx2025': t('process2025:name.page'),
    '/lx2035': t('process2035param:name.page'),
    '/lx204005': t('process204005:name.page'),
    '/lx204006': t('process204006:name.page'),
    '/lx204402': t('process204402:name.page'),
    '/lx2049': t('process2049param:name.page'),
    '/lx211101': t('process211101:name.page'),
    '/lx2113': t('process2113:name.page'),
    '/lx2123': t('process2123:name.page'),
    '/lx2124': t('process2124:name.page'),
    '/lx240001': t('process240001:name.page'),
    '/lx240007': t('process240007param:name.page'),
    '/ixdatevex': t('processdatevparam:name.page'),
    '/process-printer': t('Process Printer'),
    '/lx107104': t('process107104:name.page'),
    '/lx107105': t('process107105:name.page'),
    '/lx107110': t('process107110:name.page'),
    '/lx107115': t('process107115:name.page'),
    '/lx107232': t('process107232:name.page'),
    '/lx1090': t('process1090:name.page'),
    '/lx2052': t('process2052:name.page'),
    '/lx2053': t('process2053:name.page'),
    '/lx22001': t('process22001:name.page'),
    '/lx22002': t('process22002:name.page'),
    '/lx240004': t('process240001prodruckvgl:name.page'),
    '/lx404002': t('process404002:name.page'),
    '/lx404011': t('process404011:name.page'),
    '/ixhypothekreport': t('processhypothekreportparam:name.page'),
    '/ixintrealsapbuexp': t('processintrealparam:name.page'),
    '/ix3057': t('process3057saveparam:name.page'),
    '/ix30571ak': t('abrkarte:name.page'),
    '/lx1006': t('process1006:name.page'),
    '/lx101003': t('process101003:name.page'),
    '/lx1071041': t('process1071041:name.page'),
    '/lx107120': t('process107120:name.page'),
    '/lx107122': t('process107122:name.page'),
    '/ix107211': t('process107211:name.page'),
    '/lx1082': t('process1082:name.page'),
    '/lx109041': t('process109041:name.page'),
    '/lx200010': t('process200010:name.page'),
    '/lx20401': t('process20401:name.page'),
    '/ix3025': t('process3025:name.page'),
    '/ix3026': t('process3026:name.page'),
    '/lx304002': t('process304002:name.page'),
    '/lx304003': t('process304003:name.page'),
    '/lx304004': t('process304004:name.page'),
    '/lx304005': t('process304005:name.page'),
    '/lx304006': t('process304006:name.page'),
    '/lx304007': t('process304007:name.page'),
    '/lx304011': t('process304011:name.page'),
    '/lx304012': t('process304012:name.page'),
    '/lx40600': t('process40600:name.page'),
    '/ix6020': t('process6020berechnung:name.page'),
    '/ix2031': t('2031:name.page'),
    '/TOGesundheitsamt': t('togesundheitsamt:label.tOGesundheitsamtPage'),
    '/TOHersteller': t('tohersteller:label.tOHerstellerPage'),
    '/TORechtsgrundlagen': t('torechtsgrundlagen:label.tORechtsgrundlagenPage'),
    '/TO': t('to:label.toPage'),
    '/TODef': t('todef:label.tODefPage'),
    '/TOPruefungsart': t('topruefungsart:label.tOPruefungsartPage'),
    '/ix2050': t('ix2050:mahndaten.name.page'),
    '/lx1084': t('process1084:name.page'),
    '/lx1086': t('process1086:name.page'),
    '/ix6023': t('process6020buchen:name.page'),
    '/ix6022': t('process6020liste:name.page'),
    '/kxtrinitybuexp': t('processtrinityexport:name.page'),
    '/kxtrassetsexp': t('processtrassetsexport:name.page'),
    '/kxbisonbox': t('processbisonboxexport:name.page'),
    '/ixhansainveststdbuexp': t('processixhansainveststdbuexport:name.page'),
    '/kx0224sapbuexp': t('processkx0224sapbuexport:name.page'),
    '/kxbnpsapbuexp': t('processkxbnpsapbuexport:name.page'),
    '/kxbuuserinfoexp': t('processkxbuuserinfoexport:name.page'),
    '/': t('global:name.home'),
}


const navTree: IIxNavData[] = [
    {
        path: '#AccountStatement#',
        text: t('drawer-menu:M_2'),
        icon: 'flaticon flaticon-accounting',
        prg: 'M_2',
        favorite: false,
        items: [
            {
                path: '/ix2000bi',
                text: t('drawer-menu:ix2000bi'),
                icon: 'doc',
                prg: 'C_IX2000BI',
                favorite: false,
            },
            {
                path: '/ix2048',
                text: t('drawer-menu:ix2048'),
                icon: 'doc',
                prg: 'C_IX2048',
                favorite: false,
            },
            {
                path: '/ix2044',
                text: t('drawer-menu:ix2044'),
                icon: 'doc',
                prg: 'C_IX2044',
                favorite: false,
            },
            {
                path: '/ix2010',
                text: t('drawer-menu:ix2010'),
                icon: 'doc',
                prg: 'C_IX2010',
                favorite: false,
            },
            {
                path: '/inactive',
                text: t('drawer-menu:NCrem_BL@Kontoauszug'),
                icon: 'doc',
                prg: 'C_..\\NURIS\\NCREM.BL@KONTOAUSZUG',
                favorite: false,
            },
            {
                path: '#Sollstellung#',
                text: t('drawer-menu:M_34'),
                icon: 'doc',
                prg: 'M_34',
                favorite: false,
                items: [
                    {
                        path: '/ix20008',
                        text: t('drawer-menu:ix20008'),
                        icon: 'doc',
                        prg: 'C_IX20008',
                        favorite: false,
                    },
                    {
                        path: '/ix20008sim',
                        text: t('drawer-menu:ix20008sim'),
                        icon: 'doc',
                        prg: 'C_IX20008SIM',
                        favorite: false,
                    },
                ]
            },
            {
                path: '#Erlösschmälerung#',
                text: t('drawer-menu:M_59'),
                icon: 'doc',
                prg: 'M_59',
                favorite: false,
                items: [
                    {
                        path: '/ix200010bu',
                        text: t('drawer-menu:ix200010bu'),
                        icon: 'doc',
                        prg: 'C_IX200010BU',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:IX200010'),
                        icon: 'doc',
                        prg: 'C_IX200010',
                        favorite: false,
                    },
                    {
                        path: '#Erlösschmälerung-Druck#',
                        text: t('drawer-menu:DR200010'),
                        icon: 'print',
                        prg: 'C_DR200010',
                        favorite: false,
                        items: [
                            {
                                path: '/lx1061',
                                text: t('drawer-menu:lx1061'),
                                icon: 'doc',
                                prg: 'C_LX1061',
                                favorite: false,
                            },
                            {
                                path: '/lx200010',
                                text: t('drawer-menu:lx200010'),
                                icon: 'doc',
                                prg: 'C_LX200010',
                                favorite: false,
                            },
                        ]
                    },
                ]
            },
            {
                path: '#Zahlungsverkehr#',
                text: t('drawer-menu:M_35'),
                icon: 'doc',
                prg: 'M_35',
                favorite: false,
                items: [
                    {
                        path: '/inactive',
                        text: t('drawer-menu:ix2020'),
                        icon: 'doc',
                        prg: 'C_IX2020',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:IX2070'),
                        icon: 'doc',
                        prg: 'C_IX2070',
                        favorite: false,
                    },
                    {
                        path: '/ix202001',
                        text: t('drawer-menu:ix202001'),
                        icon: 'doc',
                        prg: 'C_IX202001',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:IX2080'),
                        icon: 'doc',
                        prg: 'C_IX2080',
                        favorite: false,
                    },
                    {
                        path: '/ix2031',
                        text: t('drawer-menu:ix2031'),
                        icon: 'packagebox',
                        prg: 'C_IX2031',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:IX202006'),
                        icon: 'doc',
                        prg: 'C_IX202006',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:IX202007'),
                        icon: 'doc',
                        prg: 'C_IX202007',
                        favorite: false,
                    },
                ]
            },
            {
                path: '#Mahnwesen#',
                text: t('drawer-menu:M_37'),
                icon: 'doc',
                prg: 'M_37',
                favorite: false,
                items: [
                    {
                        path: '/ix2050',
                        text: t('drawer-menu:ix2050'),
                        icon: 'doc',
                        prg: 'C_IX2050',
                        favorite: false,
                    },
                    {
                        path: '#Mahnwesen-Druck#',
                        text: t('drawer-menu:DR2050'),
                        icon: 'print',
                        prg: 'C_DR2050',
                        favorite: false,
                        items: [
                            {
                                path: '/lx2051',
                                text: t('drawer-menu:lx2051'),
                                icon: 'doc',
                                prg: 'C_LX2051',
                                favorite: false,
                            },
                            {
                                path: '/lx2052',
                                text: t('drawer-menu:lx2052'),
                                icon: 'doc',
                                prg: 'C_LX2052',
                                favorite: false,
                            },
                            {
                                path: '/lx2053',
                                text: t('drawer-menu:lx2053'),
                                icon: 'doc',
                                prg: 'C_LX2053',
                                favorite: false,
                            },
                        ]
                    },
                ]
            },
            {
                path: '#Umsatzsteuervoranmeldungen#',
                text: t('drawer-menu:M_15'),
                icon: 'doc',
                prg: 'M_15',
                favorite: false,
                items: [
                    {
                        path: '/inactive',
                        text: t('drawer-menu:ix2068'),
                        icon: 'doc',
                        prg: 'C_IX2068',
                        favorite: false,
                    },
                    {
                        path: '/ix2067',
                        text: t('drawer-menu:ix2067'),
                        icon: 'doc',
                        prg: 'C_IX2067',
                        favorite: false,
                    },
                ]
            },
            {
                path: '#Anlagenbuchhaltung#',
                text: t('drawer-menu:M_50'),
                icon: 'doc',
                prg: 'M_50',
                favorite: false,
                items: [
                    {
                        path: '/inactive',
                        text: t('drawer-menu:ix2110'),
                        icon: 'doc',
                        prg: 'C_IX2110',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:ix2220'),
                        icon: 'doc',
                        prg: 'C_IX2220',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:ix2117'),
                        icon: 'doc',
                        prg: 'C_IX2117',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:ix2118'),
                        icon: 'doc',
                        prg: 'C_IX2118',
                        favorite: false,
                    },
                    {
                        path: '#Einstellungen#',
                        text: t('drawer-menu:M_54'),
                        icon: 'doc',
                        prg: 'M_54',
                        favorite: false,
                        items: [
                            {
                                path: '/inactive',
                                text: t('drawer-menu:ix2113'),
                                icon: 'doc',
                                prg: 'C_IX2113',
                                favorite: false,
                            },
                            {
                                path: '/inactive',
                                text: t('drawer-menu:ix2111'),
                                icon: 'doc',
                                prg: 'C_IX2111',
                                favorite: false,
                            },
                            {
                                path: '/inactive',
                                text: t('drawer-menu:ix2112'),
                                icon: 'doc',
                                prg: 'C_IX2112',
                                favorite: false,
                            },
                        ]
                    },
                    {
                        path: '#Anlagen-Druck#',
                        text: t('drawer-menu:M_60'),
                        icon: 'print',
                        prg: 'M_60',
                        favorite: false,
                        items: [
                            {
                                path: '/lx2113',
                                text: t('drawer-menu:lx2113'),
                                icon: 'doc',
                                prg: 'C_LX2113',
                                favorite: false,
                            },
                            {
                                path: '/lx211101',
                                text: t('drawer-menu:lx211101'),
                                icon: 'doc',
                                prg: 'C_LX211101',
                                favorite: false,
                            },
                            {
                                path: '/lx2123',
                                text: t('drawer-menu:lx2123'),
                                icon: 'doc',
                                prg: 'C_LX2123',
                                favorite: false,
                            },
                            {
                                path: '/lx2124',
                                text: t('drawer-menu:lx2124'),
                                icon: 'doc',
                                prg: 'C_LX2124',
                                favorite: false,
                            },
                            {
                                path: '/inactive',
                                text: t('drawer-menu:lx2119'),
                                icon: 'doc',
                                prg: 'C_LX2119',
                                favorite: false,
                            },
                        ]
                    },
                ]
            },
            {
                path: '#Hypothekenbuchhaltung#',
                text: t('drawer-menu:M_8'),
                icon: 'doc',
                prg: 'M_8',
                favorite: false,
                items: [
                    {
                        path: '/inactive',
                        text: t('drawer-menu:ix2200'),
                        icon: 'doc',
                        prg: 'C_IX2200',
                        favorite: false,
                    },
                    {
                        path: '#Hypo-Druck#',
                        text: t('drawer-menu:DR2201'),
                        icon: 'print',
                        prg: 'C_DR2201',
                        favorite: false,
                        items: [
                            {
                                path: '/lx22001',
                                text: t('drawer-menu:lx22001'),
                                icon: 'doc',
                                prg: 'C_LX22001',
                                favorite: false,
                            },
                            {
                                path: '/lx22002',
                                text: t('drawer-menu:lx22002'),
                                icon: 'doc',
                                prg: 'C_LX22002',
                                favorite: false,
                            },
                            {
                                path: '/ixhypothekreport',
                                text: t('drawer-menu:ixhypothekreport'),
                                icon: 'doc',
                                prg: 'C_IXHYPOTHEKREPORT',
                                favorite: false,
                            },
                        ]
                    },
                ]
            },
            {
                path: '#Kautionsverwaltung#',
                text: t('drawer-menu:M_53'),
                icon: 'doc',
                prg: 'M_53',
                favorite: false,
                items: [
                    {
                        path: '/lx1230053',
                        text: t('drawer-menu:ix1230'),
                        icon: 'doc',
                        prg: 'C_IX1230',
                        favorite: false,
                    },
                    {
                        path: '#Kaution-Druck#',
                        text: t('drawer-menu:DR1230'),
                        icon: 'print',
                        prg: 'C_DR1230',
                        favorite: false,
                        items: [
                            {
                                path: '/lx1230051',
                                text: t('drawer-menu:lx1230051'),
                                icon: 'doc',
                                prg: 'C_LX1230051',
                                favorite: false,
                            },
                            {
                                path: '/lx1230053',
                                text: t('drawer-menu:lx1230053'),
                                icon: 'doc',
                                prg: 'C_LX1230053',
                                favorite: false,
                            },
                            {
                                path: '/inactive',
                                text: t('drawer-menu:ixKautionReport'),
                                icon: 'doc',
                                prg: 'C_IXKAUTIONREPORT',
                                favorite: false,
                            },
                            {
                                path: '/lx123010',
                                text: t('drawer-menu:lx123010'),
                                icon: 'doc',
                                prg: 'C_LX123010',
                                favorite: false,
                            },
                        ]
                    },
                ]
            },
            {
                path: '#Faktura#',
                text: t('drawer-menu:M_41'),
                icon: 'doc',
                prg: 'M_41',
                favorite: false,
                items: [
                    {
                        path: '/inactive',
                        text: t('drawer-menu:ix2451'),
                        icon: 'doc',
                        prg: 'C_IX2451',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:ix2452'),
                        icon: 'doc',
                        prg: 'C_IX2452',
                        favorite: false,
                    },
                    {
                        path: '#Faktura-Einstellungen#',
                        text: t('drawer-menu:M_72'),
                        icon: 'doc',
                        prg: 'M_72',
                        favorite: false,
                        items: [
                            {
                                path: '/inactive',
                                text: t('drawer-menu:ix2453'),
                                icon: 'doc',
                                prg: 'C_IX2453',
                                favorite: false,
                            },
                            {
                                path: '/inactive',
                                text: t('drawer-menu:ix2454'),
                                icon: 'doc',
                                prg: 'C_IX2454',
                                favorite: false,
                            },
                        ]
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:ix2455'),
                        icon: 'doc',
                        prg: 'C_IX2455',
                        favorite: false,
                    },
                ]
            },
            {
                path: '#Konten#',
                text: t('drawer-menu:M_48'),
                icon: 'doc',
                prg: 'M_48',
                favorite: false,
                items: [
                    {
                        path: '#Sachkonten#',
                        text: t('drawer-menu:M_43'),
                        icon: 'doc',
                        prg: 'M_43',
                        favorite: false,
                        items: [
                            {
                                path: '/inactive',
                                text: t('drawer-menu:ix1020'),
                                icon: 'doc',
                                prg: 'C_IX1020',
                                favorite: false,
                            },
                            {
                                path: '/inactive',
                                text: t('drawer-menu:ix1021'),
                                icon: 'doc',
                                prg: 'C_IX1021',
                                favorite: false,
                            },
                            {
                                path: '/ix1022',
                                text: t('drawer-menu:ix1022'),
                                icon: 'doc',
                                prg: 'C_IX1022',
                                favorite: false,
                            },
                            {
                                path: '/inactive',
                                text: t('drawer-menu:NCrem_Plus_Sachkonten'),
                                icon: 'doc',
                                prg: 'C_..\\NURIS\\NCREM.PLUS.SACHKONTEN',
                                favorite: false,
                            },
                        ]
                    },
                    {
                        path: '/ix1010',
                        text: t('drawer-menu:ix1010'),
                        icon: 'doc',
                        prg: 'C_IX1010',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:IX2047'),
                        icon: 'doc',
                        prg: 'C_IX2047',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:ix2500'),
                        icon: 'doc',
                        prg: 'C_IX2500',
                        favorite: false,
                    },
                ]
            },
            {
                path: '#Raten-/Stundungsvereinbarung#',
                text: t('drawer-menu:M_73'),
                icon: 'doc',
                prg: 'M_73',
                favorite: false,
                items: [
                    {
                        path: '/inactive',
                        text: t('drawer-menu:ix1005'),
                        icon: 'doc',
                        prg: 'C_IX1005',
                        favorite: false,
                    },
                ]
            },
            {
                path: '/inactive',
                text: t('drawer-menu:ix200030'),
                icon: 'doc',
                prg: 'C_IX200030',
                favorite: false,
            },
            {
                path: '#Einzelwertberichtigung#',
                text: t('drawer-menu:M_63'),
                icon: 'doc',
                prg: 'M_63',
                favorite: false,
                items: [
                    {
                        path: '/ix2060',
                        text: t('drawer-menu:ix2060'),
                        icon: 'doc',
                        prg: 'C_IX2060',
                        favorite: false,
                    },
                ]
            },
            {
                path: '/ix20011',
                text: t('drawer-menu:ix20011'),
                icon: 'doc',
                prg: 'C_IX20011',
                favorite: false,
            },
            {
                path: '/ix2076',
                text: t('drawer-menu:ix2076'),
                icon: 'doc',
                prg: 'C_IX2076',
                favorite: false,
            },
            {
                path: '#Buchhaltungs-Druck#',
                text: t('drawer-menu:DR2000'),
                icon: 'print',
                prg: 'C_DR2000',
                favorite: false,
                items: [
                    {
                        path: '/lx200105',
                        text: t('drawer-menu:lx200105'),
                        icon: 'doc',
                        prg: 'C_LX200105',
                        favorite: false,
                    },
                    {
                        path: '/lx2016',
                        text: t('drawer-menu:lx2016'),
                        icon: 'doc',
                        prg: 'C_LX2016',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:lx1061'),
                        icon: 'doc',
                        prg: 'C_LX1061',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:lx200010'),
                        icon: 'doc',
                        prg: 'C_LX200010',
                        favorite: false,
                    },
                    {
                        path: '/lx101002',
                        text: t('drawer-menu:lx101002'),
                        icon: 'doc',
                        prg: 'C_LX101002',
                        favorite: false,
                    },
                    {
                        path: '/lx2073',
                        text: t('drawer-menu:lx2073'),
                        icon: 'doc',
                        prg: 'C_LX2073',
                        favorite: false,
                    },
                    {
                        path: '/lx2074',
                        text: t('drawer-menu:lx2074'),
                        icon: 'doc',
                        prg: 'C_LX2074',
                        favorite: false,
                    },
                    {
                        path: '/lx2076',
                        text: t('drawer-menu:lx2076'),
                        icon: 'doc',
                        prg: 'C_LX2076',
                        favorite: false,
                    },
                    {
                        path: '/lx2072',
                        text: t('drawer-menu:lx2072'),
                        icon: 'doc',
                        prg: 'C_LX2072',
                        favorite: false,
                    },
                    {
                        path: '/lx201051',
                        text: t('drawer-menu:lx201051'),
                        icon: 'doc',
                        prg: 'C_LX201051',
                        favorite: false,
                    },
                    {
                        path: '/lx201052',
                        text: t('drawer-menu:lx201052'),
                        icon: 'doc',
                        prg: 'C_LX201052',
                        favorite: false,
                    },
                    {
                        path: '/lx201004',
                        text: t('drawer-menu:lx201004'),
                        icon: 'doc',
                        prg: 'C_LX201004',
                        favorite: false,
                    },
                    {
                        path: '/lx2075',
                        text: t('drawer-menu:lx2075'),
                        icon: 'doc',
                        prg: 'C_LX2075',
                        favorite: false,
                    },
                    {
                        path: '/lx2049',
                        text: t('drawer-menu:lx2049'),
                        icon: 'doc',
                        prg: 'C_LX2049',
                        favorite: false,
                    },
                    {
                        path: '/lx200109',
                        text: t('drawer-menu:lx200109'),
                        icon: 'doc',
                        prg: 'C_LX200109',
                        favorite: false,
                    },
                    {
                        path: '/lx204031',
                        text: t('drawer-menu:lx204031'),
                        icon: 'doc',
                        prg: 'C_LX204031',
                        favorite: false,
                    },
                    {
                        path: '/lx2003',
                        text: t('drawer-menu:lx2003'),
                        icon: 'doc',
                        prg: 'C_LX2003',
                        favorite: false,
                    },
                    {
                        path: '/lx204005',
                        text: t('drawer-menu:lx204005'),
                        icon: 'doc',
                        prg: 'C_LX204005',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:lx204034'),
                        icon: 'doc',
                        prg: 'C_LX204034',
                        favorite: false,
                    },
                    {
                        path: '/lx2031',
                        text: t('drawer-menu:lx2031'),
                        icon: 'doc',
                        prg: 'C_LX2031',
                        favorite: false,
                    },
                    {
                        path: '/lx204006',
                        text: t('drawer-menu:lx204006'),
                        icon: 'doc',
                        prg: 'C_LX204006',
                        favorite: false,
                    },
                    {
                        path: '/lx2300',
                        text: t('drawer-menu:lx2300'),
                        icon: 'doc',
                        prg: 'C_LX2300',
                        favorite: false,
                    },
                    {
                        path: '/lx2035',
                        text: t('drawer-menu:lx2035'),
                        icon: 'doc',
                        prg: 'C_LX2035',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:lx215010'),
                        icon: 'doc',
                        prg: 'C_LX215010',
                        favorite: false,
                    },
                    {
                        path: '/lx1005',
                        text: t('drawer-menu:lx1005'),
                        icon: 'doc',
                        prg: 'C_LX1005',
                        favorite: false,
                    },
                    {
                        path: '/lx102001',
                        text: t('drawer-menu:lx102001'),
                        icon: 'doc',
                        prg: 'C_LX102001',
                        favorite: false,
                    },
                    {
                        path: '/lx102003',
                        text: t('drawer-menu:lx102003'),
                        icon: 'doc',
                        prg: 'C_LX102003',
                        favorite: false,
                    },
                    {
                        path: '/lx102002',
                        text: t('drawer-menu:lx102002'),
                        icon: 'doc',
                        prg: 'C_LX102002',
                        favorite: false,
                    },
                    {
                        path: '/lx200101',
                        text: t('drawer-menu:lx200101'),
                        icon: 'doc',
                        prg: 'C_LX200101',
                        favorite: false,
                    },
                    {
                        path: '/ix2014',
                        text: t('drawer-menu:ix2014'),
                        icon: 'doc',
                        prg: 'C_IX2014',
                        favorite: false,
                    },
                    {
                        path: '/ix2013',
                        text: t('drawer-menu:ix2013'),
                        icon: 'doc',
                        prg: 'C_IX2013',
                        favorite: false,
                    },
                    {
                        path: '/lx107129',
                        text: t('drawer-menu:lx107129'),
                        icon: 'doc',
                        prg: 'C_LX107129',
                        favorite: false,
                    },
                    {
                        path: '/xspgetzlgtlrz-page',
                        text: t('drawer-menu:lx20011'),
                        icon: 'doc',
                        prg: 'C_LX20011',
                        favorite: false,
                    },
                    {
                        path: '/lx200120',
                        text: t('drawer-menu:lx200120'),
                        icon: 'doc',
                        prg: 'C_LX200120',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:lx200116'),
                        icon: 'doc',
                        prg: 'C_LX200116',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:lx200130'),
                        icon: 'doc',
                        prg: 'C_LX200130',
                        favorite: false,
                    },
                    {
                        path: '/lx200140',
                        text: t('drawer-menu:lx200140'),
                        icon: 'doc',
                        prg: 'C_LX200140',
                        favorite: false,
                    },
                    {
                        path: '/lx204402',
                        text: t('drawer-menu:lx204402'),
                        icon: 'doc',
                        prg: 'C_LX204402',
                        favorite: false,
                    },
                ]
            },
        ]
    },
    {
        path: '#Stammdaten#',
        text: t('drawer-menu:M_3'),
        icon: 'ix-icon icon-stammdaten',
        prg: 'M_3',
        favorite: false,
        items: [
            {
                path: '/ixobject',
                text: t('drawer-menu:ixobject'),
                icon: 'doc',
                prg: 'C_IXOBJECT',
                favorite: false,
            },
            {
                path: '/inactive',
                text: t('drawer-menu:ixobjectstructure'),
                icon: 'ix-icon icon-FlAnt',
                prg: 'C_IXOBJECTSTRUCTURE',
                favorite: false,
            },
            {
                path: '/inactive',
                text: t('drawer-menu:kx884ga'),
                icon: 'doc',
                prg: 'C_KX884GA',
                favorite: false,
            },
            {
                path: '#Flächenmanagement#',
                text: t('drawer-menu:M_13'),
                icon: 'ix-icon icon-floor_plan3d2',
                prg: 'M_13',
                favorite: false,
                items: [
                    {
                        path: '/ix1072',
                        text: t('drawer-menu:ix1072'),
                        icon: 'flaticon flaticon-deal',
                        prg: 'C_IX1072',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:ix1073'),
                        icon: 'doc',
                        prg: 'C_IX1073',
                        favorite: false,
                    },
                    {
                        path: '/ix1071',
                        text: t('drawer-menu:ix1071'),
                        icon: 'ix-icon icon-floor_plan3d2',
                        prg: 'C_IX1071',
                        favorite: false,
                    },
                    {
                        path: '/ix1070',
                        text: t('drawer-menu:ix1070'),
                        icon: 'doc',
                        prg: 'C_IX1070',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:NCrem_BL@Flarten'),
                        icon: 'doc',
                        prg: 'C_..\\NURIS\\NCREM.BL@FLARTEN',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:ix1400'),
                        icon: 'doc',
                        prg: 'C_IX1400',
                        favorite: false,
                    },
                ]
            },
            {
                path: '/ix1000',
                text: t('drawer-menu:ix1000'),
                icon: 'doc',
                prg: 'C_IX1000',
                favorite: false,
            },
            {
                path: '/inactive',
                text: t('drawer-menu:IX2040'),
                icon: 'doc',
                prg: 'C_IX2040',
                favorite: false,
            },
            {
                path: '#Partner#',
                text: t('drawer-menu:M_74'),
                icon: 'doc',
                prg: 'M_74',
                favorite: false,
                items: [
                    {
                        path: '/inactive',
                        text: t('drawer-menu:NCrem_BL@GavPersonView'),
                        icon: 'doc',
                        prg: 'C_..\\NURIS\\NCREM.BL@GAVPERSONVIEW',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:NCrem_BL@GavUnternehmenView'),
                        icon: 'doc',
                        prg: 'C_..\\NURIS\\NCREM.BL@GAVUNTERNEHMENVIEW',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:NCrem_BL@GavUnternehmenNiederlassungen'),
                        icon: 'doc',
                        prg: 'C_..\\NURIS\\NCREM.BL@GAVUNTERNEHMENNIEDERLASSUNGEN',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:NCrem_BL@GavPartnerView'),
                        icon: 'doc',
                        prg: 'C_..\\NURIS\\NCREM.BL@GAVPARTNERVIEW',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:NCrem_BL@GavIxPersonView'),
                        icon: 'doc',
                        prg: 'C_..\\NURIS\\NCREM.BL@GAVIXPERSONVIEW',
                        favorite: false,
                    },
                    {
                        path: '#Rollen#',
                        text: t('drawer-menu:M_75'),
                        icon: 'doc',
                        prg: 'M_75',
                        favorite: false,
                        items: [
                            {
                                path: '/inactive',
                                text: t('drawer-menu:NCrem_BL@GavMieterView'),
                                icon: 'doc',
                                prg: 'C_..\\NURIS\\NCREM.BL@GAVMIETERVIEW',
                                favorite: false,
                            },
                            {
                                path: '/inactive',
                                text: t('drawer-menu:NCrem_BL@GavMitgliedView'),
                                icon: 'doc',
                                prg: 'C_..\\NURIS\\NCREM.BL@GAVMITGLIEDVIEW',
                                favorite: false,
                            },
                            {
                                path: '/inactive',
                                text: t('drawer-menu:NCrem_BL@GavWEGEigentuemerView'),
                                icon: 'doc',
                                prg: 'C_..\\NURIS\\NCREM.BL@GAVWEGEIGENTUEMERVIEW',
                                favorite: false,
                            },
                            {
                                path: '/inactive',
                                text: t('drawer-menu:NCrem_BL@GavSEVAuftraggeberView'),
                                icon: 'doc',
                                prg: 'C_..\\NURIS\\NCREM.BL@GAVSEVAUFTRAGGEBERVIEW',
                                favorite: false,
                            },
                            {
                                path: '/inactive',
                                text: t('drawer-menu:NCrem_BL@GavVermieterView'),
                                icon: 'doc',
                                prg: 'C_..\\NURIS\\NCREM.BL@GAVVERMIETERVIEW',
                                favorite: false,
                            },
                            {
                                path: '/inactive',
                                text: t('drawer-menu:NCrem_BL@GavObjekteigentuemerView'),
                                icon: 'doc',
                                prg: 'C_..\\NURIS\\NCREM.BL@GAVOBJEKTEIGENTUEMERVIEW',
                                favorite: false,
                            },
                            {
                                path: '/inactive',
                                text: t('drawer-menu:NCrem_BL@GavSchreibenEmpfaengerView'),
                                icon: 'doc',
                                prg: 'C_..\\NURIS\\NCREM.BL@GAVSCHREIBENEMPFAENGERVIEW',
                                favorite: false,
                            },
                            {
                                path: '/inactive',
                                text: t('drawer-menu:NCrem_BL@GavMitarbeiterView'),
                                icon: 'doc',
                                prg: 'C_..\\NURIS\\NCREM.BL@GAVMITARBEITERVIEW',
                                favorite: false,
                            },
                            {
                                path: '/inactive',
                                text: t('drawer-menu:NCrem_BL@GavInteressentView'),
                                icon: 'doc',
                                prg: 'C_..\\NURIS\\NCREM.BL@GAVINTERESSENTVIEW',
                                favorite: false,
                            },
                        ]
                    },
                ]
            },
            {
                path: '/ix1033',
                text: t('drawer-menu:ix1033'),
                icon: 'ix-icon icon-FlAnt',
                prg: 'C_IX1033',
                favorite: false,
            },
            {
                path: '/ix1060',
                text: t('drawer-menu:ix1060'),
                icon: 'doc',
                prg: 'C_IX1060',
                favorite: false,
            },
            {
                path: '/ixbetkreis',
                text: t('drawer-menu:ixbetkreis'),
                icon: 'ix-icon icon-BtKreise',
                prg: 'C_IXBETKREIS',
                favorite: false,
            },
            {
                path: '/inactive',
                text: t('drawer-menu:ix1048'),
                icon: 'doc',
                prg: 'C_IX1048',
                favorite: false,
            },
            {
                path: '/inactive',
                text: t('drawer-menu:NCrem_Nuris_Beschluss'),
                icon: 'doc',
                prg: 'C_..\\NURIS\\NCREM.NURIS.BESCHLUSS',
                favorite: false,
            },
            {
                path: '#Stammdaten-Druck#',
                text: t('drawer-menu:DR1000'),
                icon: 'print',
                prg: 'C_DR1000',
                favorite: false,
                items: [
                    {
                        path: '/lx109041',
                        text: t('drawer-menu:lx109041'),
                        icon: 'doc',
                        prg: 'C_LX109041',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:lx117235'),
                        icon: 'doc',
                        prg: 'C_LX117235',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:lx11729'),
                        icon: 'doc',
                        prg: 'C_LX11729',
                        favorite: false,
                    },
                    {
                        path: '/lx107135',
                        text: t('drawer-menu:lx107135'),
                        icon: 'doc',
                        prg: 'C_LX107135',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:lx1002'),
                        icon: 'doc',
                        prg: 'C_LX1002',
                        favorite: false,
                    },
                    {
                        path: '/lx101003',
                        text: t('drawer-menu:lx101003'),
                        icon: 'doc',
                        prg: 'C_LX101003',
                        favorite: false,
                    },
                    {
                        path: '/lx20401',
                        text: t('drawer-menu:lx20401'),
                        icon: 'doc',
                        prg: 'C_LX20401',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:lx11723'),
                        icon: 'doc',
                        prg: 'C_LX11723',
                        favorite: false,
                    },
                    {
                        path: '/lx200085',
                        text: t('drawer-menu:lx200085'),
                        icon: 'doc',
                        prg: 'C_LX200085',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:lx1061'),
                        icon: 'doc',
                        prg: 'C_LX1061',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:lx200010'),
                        icon: 'doc',
                        prg: 'C_LX200010',
                        favorite: false,
                    },
                    {
                        path: '/lx107050',
                        text: t('drawer-menu:lx107050'),
                        icon: 'doc',
                        prg: 'C_LX107050',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:lx1055'),
                        icon: 'doc',
                        prg: 'C_LX1055',
                        favorite: false,
                    },
                    {
                        path: '/lx1040',
                        text: t('drawer-menu:lx1040'),
                        icon: 'doc',
                        prg: 'C_LX1040',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:lx107002'),
                        icon: 'doc',
                        prg: 'C_LX107002',
                        favorite: false,
                    },
                    {
                        path: '/lx107122',
                        text: t('drawer-menu:lx107122'),
                        icon: 'doc',
                        prg: 'C_LX107122',
                        favorite: false,
                    },
                    {
                        path: '/lx107102',
                        text: t('drawer-menu:lx107102'),
                        icon: 'doc',
                        prg: 'C_LX107102',
                        favorite: false,
                    },
                    {
                        path: '/lx107101',
                        text: t('drawer-menu:lx107101'),
                        icon: 'doc',
                        prg: 'C_LX107101',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:lx1047'),
                        icon: 'doc',
                        prg: 'C_LX1047',
                        favorite: false,
                    },
                    {
                        path: '/lx107106',
                        text: t('drawer-menu:lx107106'),
                        icon: 'doc',
                        prg: 'C_LX107106',
                        favorite: false,
                    },
                    {
                        path: '/lx107103',
                        text: t('drawer-menu:lx107103'),
                        icon: 'doc',
                        prg: 'C_LX107103',
                        favorite: false,
                    },
                    {
                        path: '/lx107123',
                        text: t('drawer-menu:lx107123'),
                        icon: 'doc',
                        prg: 'C_LX107123',
                        favorite: false,
                    },
                    {
                        path: '/lx107128',
                        text: t('drawer-menu:lx107128'),
                        icon: 'doc',
                        prg: 'C_LX107128',
                        favorite: false,
                    },
                    {
                        path: '/lx107120',
                        text: t('drawer-menu:lx107120'),
                        icon: 'doc',
                        prg: 'C_LX107120',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:lx107118'),
                        icon: 'doc',
                        prg: 'C_LX107118',
                        favorite: false,
                    },
                    {
                        path: '/ix2011',
                        text: t('drawer-menu:ix2011'),
                        icon: 'doc',
                        prg: 'C_IX2011',
                        favorite: false,
                    },
                    {
                        path: '/lx107104',
                        text: t('drawer-menu:lx107104'),
                        icon: 'doc',
                        prg: 'C_LX107104',
                        favorite: false,
                    },
                    {
                        path: '/lx107108',
                        text: t('drawer-menu:lx107108'),
                        icon: 'doc',
                        prg: 'C_LX107108',
                        favorite: false,
                    },
                    {
                        path: '/lx107109',
                        text: t('drawer-menu:lx107109'),
                        icon: 'doc',
                        prg: 'C_LX107109',
                        favorite: false,
                    },
                    {
                        path: '/lx107110',
                        text: t('drawer-menu:lx107110'),
                        icon: 'doc',
                        prg: 'C_LX107110',
                        favorite: false,
                    },
                    {
                        path: '/lx11722',
                        text: t('drawer-menu:lx11722'),
                        icon: 'doc',
                        prg: 'C_LX11722',
                        favorite: false,
                    },
                    {
                        path: '/lx11725',
                        text: t('drawer-menu:lx11725'),
                        icon: 'doc',
                        prg: 'C_LX11725',
                        favorite: false,
                    },
                    {
                        path: '/lx107113',
                        text: t('drawer-menu:lx107113'),
                        icon: 'doc',
                        prg: 'C_LX107113',
                        favorite: false,
                    },
                    {
                        path: '/lx1021',
                        text: t('drawer-menu:lx1021'),
                        icon: 'doc',
                        prg: 'C_LX1021',
                        favorite: false,
                    },
                    {
                        path: '/lx107105',
                        text: t('drawer-menu:lx107105'),
                        icon: 'doc',
                        prg: 'C_LX107105',
                        favorite: false,
                    },
                    {
                        path: '/lx1001',
                        text: t('drawer-menu:lx1001'),
                        icon: 'doc',
                        prg: 'C_LX1001',
                        favorite: false,
                    },
                    {
                        path: '/lx1003',
                        text: t('drawer-menu:lx1003'),
                        icon: 'doc',
                        prg: 'C_LX1003',
                        favorite: false,
                    },
                    {
                        path: '/lx1006',
                        text: t('drawer-menu:lx1006'),
                        icon: 'doc',
                        prg: 'C_LX1006',
                        favorite: false,
                    },
                    {
                        path: '/lx1090',
                        text: t('drawer-menu:lx1090'),
                        icon: 'doc',
                        prg: 'C_LX1090',
                        favorite: false,
                    },
                    {
                        path: '/lx107232',
                        text: t('drawer-menu:lx107232'),
                        icon: 'doc',
                        prg: 'C_LX107232',
                        favorite: false,
                    },
                    {
                        path: '/lx103002',
                        text: t('drawer-menu:lx103002'),
                        icon: 'doc',
                        prg: 'C_LX103002',
                        favorite: false,
                    },
                    {
                        path: '/lx40604',
                        text: t('drawer-menu:lx40604'),
                        icon: 'doc',
                        prg: 'C_LX40604',
                        favorite: false,
                    },
                    {
                        path: '/lx40606',
                        text: t('drawer-menu:lx40606'),
                        icon: 'doc',
                        prg: 'C_LX40606',
                        favorite: false,
                    },
                    {
                        path: '/lx40600',
                        text: t('drawer-menu:lx40600'),
                        icon: 'doc',
                        prg: 'C_LX40600',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:lx40609'),
                        icon: 'doc',
                        prg: 'C_LX40609',
                        favorite: false,
                    },
                    {
                        path: '/lx107049',
                        text: t('drawer-menu:lx107049'),
                        icon: 'doc',
                        prg: 'C_LX107049',
                        favorite: false,
                    },
                    {
                        path: '/lx107055',
                        text: t('drawer-menu:lx107055'),
                        icon: 'doc',
                        prg: 'C_LX107055',
                        favorite: false,
                    },
                    {
                        path: '/lx107115',
                        text: t('drawer-menu:lx107115'),
                        icon: 'doc',
                        prg: 'C_LX107115',
                        favorite: false,
                    },
                    {
                        path: '/lx1071041',
                        text: t('drawer-menu:lx1071041'),
                        icon: 'doc',
                        prg: 'C_LX1071041',
                        favorite: false,
                    },
                    {
                        path: '/lx1082',
                        text: t('drawer-menu:lx1082'),
                        icon: 'doc',
                        prg: 'C_LX1082',
                        favorite: false,
                    },
                ]
            },
            {
                path: '/ixWebOwner',
                text: t('drawer-menu:ixWebOwner'),
                icon: 'doc',
                prg: 'C_IXWEBOWNER',
                favorite: false,
            },
        ]
    },
    {
        path: '#Mietanpassungen#',
        text: t('drawer-menu:M_77'),
        icon: 'doc',
        prg: 'M_77',
        favorite: false,
        items: [
            {
                path: '/inactive',
                text: t('drawer-menu:IX4075'),
                icon: 'doc',
                prg: 'C_IX4075',
                favorite: false,
            },
            {
                path: '#Mietspiegel (alt)#',
                text: t('drawer-menu:M_46'),
                icon: 'doc',
                prg: 'M_46',
                favorite: false,
                items: [
                    {
                        path: '/inactive',
                        text: t('drawer-menu:ix4086'),
                        icon: 'doc',
                        prg: 'C_IX4086',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:ix4084'),
                        icon: 'doc',
                        prg: 'C_IX4084',
                        favorite: false,
                    },
                ]
            },
            {
                path: '/inactive',
                text: t('drawer-menu:NCrem_BL@Mietspiegel'),
                icon: 'doc',
                prg: 'C_..\\NURIS\\NCREM.BL@MIETSPIEGEL',
                favorite: false,
            },
            {
                path: '/inactive',
                text: t('drawer-menu:IX4077'),
                icon: 'doc',
                prg: 'C_IX4077',
                favorite: false,
            },
            {
                path: '#Index#',
                text: t('drawer-menu:M_62'),
                icon: 'doc',
                prg: 'M_62',
                favorite: false,
                items: [
                    {
                        path: '/inactive',
                        text: t('drawer-menu:ix4040'),
                        icon: 'doc',
                        prg: 'C_IX4040',
                        favorite: false,
                    },
                    {
                        path: '/ix404050',
                        text: t('drawer-menu:ix404050'),
                        icon: 'doc',
                        prg: 'C_IX404050',
                        favorite: false,
                    },
                    {
                        path: '#Indexanpassung (alt)#',
                        text: t('drawer-menu:M_82'),
                        icon: 'doc',
                        prg: 'M_82',
                        favorite: false,
                        items: [
                            {
                                path: '/lx404051',
                                text: t('drawer-menu:lx404051'),
                                icon: 'doc',
                                prg: 'C_LX404051',
                                favorite: false,
                            },
                            {
                                path: '/lx404052',
                                text: t('drawer-menu:lx404052'),
                                icon: 'doc',
                                prg: 'C_LX404052',
                                favorite: false,
                            },
                            {
                                path: '/lx404053',
                                text: t('drawer-menu:lx404053'),
                                icon: 'doc',
                                prg: 'C_LX404053',
                                favorite: false,
                            },
                        ]
                    },
                    {
                        path: '#Index-Druck#',
                        text: t('drawer-menu:DR4040'),
                        icon: 'print',
                        prg: 'C_DR4040',
                        favorite: false,
                        items: [
                            {
                                path: '/lx404002',
                                text: t('drawer-menu:lx404002'),
                                icon: 'doc',
                                prg: 'C_LX404002',
                                favorite: false,
                            },
                            {
                                path: '/lx404011',
                                text: t('drawer-menu:lx404011'),
                                icon: 'doc',
                                prg: 'C_LX404011',
                                favorite: false,
                            },
                        ]
                    },
                ]
            },
            {
                path: '#Flächenumsatzmieten#',
                text: t('drawer-menu:M_17'),
                icon: 'doc',
                prg: 'M_17',
                favorite: false,
                items: [
                    {
                        path: '/inactive',
                        text: t('drawer-menu:ix1170'),
                        icon: 'doc',
                        prg: 'C_IX1170',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:ix1171'),
                        icon: 'doc',
                        prg: 'C_IX1171',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:lx40611'),
                        icon: 'doc',
                        prg: 'C_LX40611',
                        favorite: false,
                    },
                ]
            },
            {
                path: '/inactive',
                text: t('drawer-menu:LX1082'),
                icon: 'doc',
                prg: 'C_LX1082',
                favorite: false,
            },
            {
                path: '/lx1084',
                text: t('drawer-menu:lx1084'),
                icon: 'doc',
                prg: 'C_LX1084',
                favorite: false,
            },
            {
                path: '/lx1086',
                text: t('drawer-menu:lx1086'),
                icon: 'doc',
                prg: 'C_LX1086',
                favorite: false,
            },
            {
                path: '/inactive',
                text: t('drawer-menu:IX40301'),
                icon: 'doc',
                prg: 'C_IX40301',
                favorite: false,
            },
        ]
    },
    {
        path: '#Mitgliederverwaltung#',
        text: t('drawer-menu:M_9'),
        icon: 'doc',
        prg: 'M_9',
        favorite: false,
        items: [
            {
                path: '/ix1000',
                text: t('drawer-menu:ix1000'),
                icon: 'doc',
                prg: 'C_IX1000',
                favorite: false,
            },
            {
                path: '#Dividende#',
                text: t('drawer-menu:M_69'),
                icon: 'doc',
                prg: 'M_69',
                favorite: false,
                items: [
                    {
                        path: '/ix6020',
                        text: t('drawer-menu:ix6020'),
                        icon: 'doc',
                        prg: 'C_IX6020',
                        favorite: false,
                    },
                    {
                        path: '/ix6022',
                        text: t('drawer-menu:ix6022'),
                        icon: 'doc',
                        prg: 'C_IX6022',
                        favorite: false,
                    },
                    {
                        path: '/ix6023',
                        text: t('drawer-menu:ix6023'),
                        icon: 'doc',
                        prg: 'C_IX6023',
                        favorite: false,
                    },
                ]
            },
            {
                path: '/inactive',
                text: t('drawer-menu:ix6040'),
                icon: 'doc',
                prg: 'C_IX6040',
                favorite: false,
            },
            {
                path: '/inactive',
                text: t('drawer-menu:ix1603kista'),
                icon: 'doc',
                prg: 'C_IX1603KISTA',
                favorite: false,
            },
            {
                path: '/inactive',
                text: t('drawer-menu:ix6039'),
                icon: 'doc',
                prg: 'C_IX6039',
                favorite: false,
            },
            {
                path: '#Mitgliederverwaltung-Druck#',
                text: t('drawer-menu:M_70'),
                icon: 'print',
                prg: 'M_70',
                favorite: false,
                items: [
                    {
                        path: '/inactive',
                        text: t('drawer-menu:lx60305'),
                        icon: 'doc',
                        prg: 'C_LX60305',
                        favorite: false,
                    },
                ]
            },
        ]
    },
    {
        path: '#Abrechnung#',
        text: t('drawer-menu:M_5'),
        icon: 'doc',
        prg: 'M_5',
        favorite: false,
        items: [
            {
                path: '#Verwaltungsabrechnungen#',
                text: t('drawer-menu:M_27'),
                icon: 'doc',
                prg: 'M_27',
                favorite: false,
                items: [
                    {
                        path: '/inactive',
                        text: t('drawer-menu:ix3095'),
                        icon: 'doc',
                        prg: 'C_IX3095',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:IX3020'),
                        icon: 'doc',
                        prg: 'C_IX3020',
                        favorite: false,
                    },
                    {
                        path: '#Verwaltungsabr. (Global)#',
                        text: t('drawer-menu:M_47'),
                        icon: 'doc',
                        prg: 'M_47',
                        favorite: false,
                        items: [
                            {
                                path: '/inactive',
                                text: t('drawer-menu:ix1430'),
                                icon: 'doc',
                                prg: 'C_IX1430',
                                favorite: false,
                            },
                            {
                                path: '/ix3025',
                                text: t('drawer-menu:ix3025'),
                                icon: 'doc',
                                prg: 'C_IX3025',
                                favorite: false,
                            },
                            {
                                path: '/ix3026',
                                text: t('drawer-menu:ix3026'),
                                icon: 'doc',
                                prg: 'C_IX3026',
                                favorite: false,
                            },
                            {
                                path: '/inactive',
                                text: t('drawer-menu:ix2022'),
                                icon: 'doc',
                                prg: 'C_IX2022',
                                favorite: false,
                            },
                            {
                                path: '#Druckmenü#',
                                text: t('drawer-menu:DR1430'),
                                icon: 'doc',
                                prg: 'C_DR1430',
                                favorite: false,
                                items: [
                                    {
                                        path: '/inactive',
                                        text: t('drawer-menu:lx1430'),
                                        icon: 'doc',
                                        prg: 'C_LX1430',
                                        favorite: false,
                                    },
                                    {
                                        path: '/inactive',
                                        text: t('drawer-menu:lx1431'),
                                        icon: 'doc',
                                        prg: 'C_LX1431',
                                        favorite: false,
                                    },
                                    {
                                        path: '/inactive',
                                        text: t('drawer-menu:lx1106'),
                                        icon: 'doc',
                                        prg: 'C_LX1106',
                                        favorite: false,
                                    },
                                    {
                                        path: '/inactive',
                                        text: t('drawer-menu:ix3025'),
                                        icon: 'doc',
                                        prg: 'C_IX3025',
                                        favorite: false,
                                    },
                                    {
                                        path: '/inactive',
                                        text: t('drawer-menu:ix3026'),
                                        icon: 'doc',
                                        prg: 'C_IX3026',
                                        favorite: false,
                                    },
                                ]
                            },
                        ]
                    },
                ]
            },
            {
                path: '/ix3057',
                text: t('drawer-menu:ix3057'),
                icon: 'doc',
                prg: 'C_IX3057',
                favorite: false,
            },
            {
                path: '/inactive',
                text: t('drawer-menu:IX3057nb'),
                icon: 'doc',
                prg: 'C_IX3057NB',
                favorite: false,
            },
            {
                path: '/ix30571ak',
                text: t('drawer-menu:ix30571ak'),
                icon: 'doc',
                prg: 'C_IX30571AK',
                favorite: false,
            },
            {
                path: '/inactive',
                text: t('drawer-menu:ix30571uj'),
                icon: 'doc',
                prg: 'C_IX30571UJ',
                favorite: false,
            },
            {
                path: '/inactive',
                text: t('drawer-menu:ix30573'),
                icon: 'doc',
                prg: 'C_IX30573',
                favorite: false,
            },
            {
                path: '/inactive',
                text: t('drawer-menu:NCrem_BL@Abrechnungsampel'),
                icon: 'doc',
                prg: 'C_..\\NURIS\\NCREM.BL@ABRECHNUNGSAMPEL',
                favorite: false,
            },
            {
                path: '#Hausgeldabrechnung#',
                text: t('drawer-menu:M_32'),
                icon: 'doc',
                prg: 'M_32',
                favorite: false,
                items: [
                    {
                        path: '/inactive',
                        text: t('drawer-menu:IX3058'),
                        icon: 'doc',
                        prg: 'C_IX3058',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:ix3050'),
                        icon: 'doc',
                        prg: 'C_IX3050',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:ixvermstatus'),
                        icon: 'doc',
                        prg: 'C_IXVERMSTATUS',
                        favorite: false,
                    },
                    {
                        path: '/ix3010',
                        text: t('drawer-menu:ix3010'),
                        icon: 'doc',
                        prg: 'C_IX3010',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:IX3090'),
                        icon: 'doc',
                        prg: 'C_IX3090',
                        favorite: false,
                    },
                ]
            },
            {
                path: '/inactive',
                text: t('drawer-menu:ix3029'),
                icon: 'doc',
                prg: 'C_IX3029',
                favorite: false,
            },
            {
                path: '/inactive',
                text: t('drawer-menu:ix3097'),
                icon: 'doc',
                prg: 'C_IX3097',
                favorite: false,
            },
            {
                path: '/inactive',
                text: t('drawer-menu:ix2000hndl'),
                icon: 'doc',
                prg: 'C_IX2000HNDL',
                favorite: false,
            },
            {
                path: '/inactive',
                text: t('drawer-menu:DR3000'),
                icon: 'doc',
                prg: 'C_DR3000',
                favorite: false,
            },
        ]
    },
    {
        path: '#Budget/Projektverwaltung#',
        text: t('drawer-menu:M_76'),
        icon: 'doc',
        prg: 'M_76',
        favorite: false,
        items: [
            {
                path: '/inactive',
                text: t('drawer-menu:ix4050'),
                icon: 'doc',
                prg: 'C_IX4050',
                favorite: false,
            },
            {
                path: '/inactive',
                text: t('drawer-menu:ix4052'),
                icon: 'doc',
                prg: 'C_IX4052',
                favorite: false,
            },
            {
                path: '#Projektverwaltung#',
                text: t('drawer-menu:M_7'),
                icon: 'doc',
                prg: 'M_7',
                favorite: false,
                items: [
                    {
                        path: '/lx240002',
                        text: t('drawer-menu:ix2400'),
                        icon: 'flaticon flaticon-deal',
                        prg: 'C_IX2400',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:NCrem_Plus_Projekt'),
                        icon: 'doc',
                        prg: 'C_..\\NURIS\\NCREM.PLUS.PROJEKT',
                        favorite: false,
                    },
                    {
                        path: '#Projekt-Druck#',
                        text: t('drawer-menu:DR7000'),
                        icon: 'print',
                        prg: 'C_DR7000',
                        favorite: false,
                        items: [
                            {
                                path: '/lx240001',
                                text: t('drawer-menu:lx240001'),
                                icon: 'doc',
                                prg: 'C_LX240001',
                                favorite: false,
                            },
                            {
                                path: '/lx240002',
                                text: t('drawer-menu:lx240002'),
                                icon: 'doc',
                                prg: 'C_LX240002',
                                favorite: false,
                            },
                            {
                                path: '/lx240004',
                                text: t('drawer-menu:lx240004'),
                                icon: 'doc',
                                prg: 'C_LX240004',
                                favorite: false,
                            },
                            {
                                path: '/inactive',
                                text: t('drawer-menu:lx240005'),
                                icon: 'doc',
                                prg: 'C_LX240005',
                                favorite: false,
                            },
                            {
                                path: '/inactive',
                                text: t('drawer-menu:lx240006'),
                                icon: 'doc',
                                prg: 'C_LX240006',
                                favorite: false,
                            },
                            {
                                path: '/lx240007',
                                text: t('drawer-menu:lx240007'),
                                icon: 'doc',
                                prg: 'C_LX240007',
                                favorite: false,
                            },
                        ]
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:ixProjektReport'),
                        icon: 'doc',
                        prg: 'C_IXPROJEKTREPORT',
                        favorite: false,
                    },
                ]
            },
        ]
    },
    {
        path: '#Auswertungen#',
        text: t('drawer-menu:M_12'),
        icon: 'doc',
        prg: 'M_12',
        favorite: false,
        items: [
            {
                path: '/inactive',
                text: t('drawer-menu:IX3010'),
                icon: 'doc',
                prg: 'C_IX3010',
                favorite: false,
            },
            {
                path: '/inactive',
                text: t('drawer-menu:IX4051'),
                icon: 'doc',
                prg: 'C_IX4051',
                favorite: false,
            },
            {
                path: '/inactive',
                text: t('drawer-menu:IX3035'),
                icon: 'doc',
                prg: 'C_IX3035',
                favorite: false,
            },
            {
                path: '/inactive',
                text: t('drawer-menu:ixBilGuvReport'),
                icon: 'doc',
                prg: 'C_IXBILGUVREPORT',
                favorite: false,
            },
            {
                path: '#B W A#',
                text: t('drawer-menu:M_51'),
                icon: 'doc',
                prg: 'M_51',
                favorite: false,
                items: [
                    {
                        path: '/inactive',
                        text: t('drawer-menu:IX3040'),
                        icon: 'doc',
                        prg: 'C_IX3040',
                        favorite: false,
                    },
                    {
                        path: '/lx304005',
                        text: t('drawer-menu:lx304005'),
                        icon: 'doc',
                        prg: 'C_LX304005',
                        favorite: false,
                    },
                    {
                        path: '/lx304002',
                        text: t('drawer-menu:lx304002'),
                        icon: 'doc',
                        prg: 'C_LX304002',
                        favorite: false,
                    },
                    {
                        path: '/lx304004',
                        text: t('drawer-menu:lx304004'),
                        icon: 'doc',
                        prg: 'C_LX304004',
                        favorite: false,
                    },
                    {
                        path: '/lx304003',
                        text: t('drawer-menu:lx304003'),
                        icon: 'doc',
                        prg: 'C_LX304003',
                        favorite: false,
                    },
                    {
                        path: '/lx304006',
                        text: t('drawer-menu:lx304006'),
                        icon: 'doc',
                        prg: 'C_LX304006',
                        favorite: false,
                    },
                    {
                        path: '/lx304007',
                        text: t('drawer-menu:lx304007'),
                        icon: 'doc',
                        prg: 'C_LX304007',
                        favorite: false,
                    },
                    {
                        path: '/lx304011',
                        text: t('drawer-menu:lx304011'),
                        icon: 'doc',
                        prg: 'C_LX304011',
                        favorite: false,
                    },
                    {
                        path: '/lx304012',
                        text: t('drawer-menu:lx304012'),
                        icon: 'doc',
                        prg: 'C_LX304012',
                        favorite: false,
                    },
                ]
            },
            {
                path: '/inactive',
                text: t('drawer-menu:IX9000'),
                icon: 'doc',
                prg: 'C_IX9000',
                favorite: false,
            },
            {
                path: '/lx2025',
                text: t('drawer-menu:lx2025'),
                icon: 'doc',
                prg: 'C_LX2025',
                favorite: false,
            },
        ]
    },
    {
        path: '#Berichtscenter#',
        text: t('drawer-menu:M_57'),
        icon: 'doc',
        prg: 'M_57',
        favorite: false,
        items: [
            {
                path: '#Buchhaltungs-Druck#',
                text: t('drawer-menu:DR2000'),
                icon: 'print',
                prg: 'C_DR2000',
                favorite: false,
                items: [
                    {
                        path: '/lx200105',
                        text: t('drawer-menu:lx200105'),
                        icon: 'doc',
                        prg: 'C_LX200105',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:lx2016'),
                        icon: 'doc',
                        prg: 'C_LX2016',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:lx1061'),
                        icon: 'doc',
                        prg: 'C_LX1061',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:lx200010'),
                        icon: 'doc',
                        prg: 'C_LX200010',
                        favorite: false,
                    },
                    {
                        path: '/lx101002',
                        text: t('drawer-menu:lx101002'),
                        icon: 'doc',
                        prg: 'C_LX101002',
                        favorite: false,
                    },
                    {
                        path: '/lx2073',
                        text: t('drawer-menu:lx2073'),
                        icon: 'doc',
                        prg: 'C_LX2073',
                        favorite: false,
                    },
                    {
                        path: '/lx2074',
                        text: t('drawer-menu:lx2074'),
                        icon: 'doc',
                        prg: 'C_LX2074',
                        favorite: false,
                    },
                    {
                        path: '/lx2076',
                        text: t('drawer-menu:lx2076'),
                        icon: 'doc',
                        prg: 'C_LX2076',
                        favorite: false,
                    },
                    {
                        path: '/lx2072',
                        text: t('drawer-menu:lx2072'),
                        icon: 'doc',
                        prg: 'C_LX2072',
                        favorite: false,
                    },
                    {
                        path: '/lx201051',
                        text: t('drawer-menu:lx201051'),
                        icon: 'doc',
                        prg: 'C_LX201051',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:lx201052'),
                        icon: 'doc',
                        prg: 'C_LX201052',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:lx201004'),
                        icon: 'doc',
                        prg: 'C_LX201004',
                        favorite: false,
                    },
                    {
                        path: '/lx2075',
                        text: t('drawer-menu:lx2075'),
                        icon: 'doc',
                        prg: 'C_LX2075',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:lx2049'),
                        icon: 'doc',
                        prg: 'C_LX2049',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:lx200109'),
                        icon: 'doc',
                        prg: 'C_LX200109',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:lx204031'),
                        icon: 'doc',
                        prg: 'C_LX204031',
                        favorite: false,
                    },
                    {
                        path: '/lx2003',
                        text: t('drawer-menu:lx2003'),
                        icon: 'doc',
                        prg: 'C_LX2003',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:lx204005'),
                        icon: 'doc',
                        prg: 'C_LX204005',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:lx204034'),
                        icon: 'doc',
                        prg: 'C_LX204034',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:lx2031'),
                        icon: 'doc',
                        prg: 'C_LX2031',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:lx204006'),
                        icon: 'doc',
                        prg: 'C_LX204006',
                        favorite: false,
                    },
                    {
                        path: '/lx2300',
                        text: t('drawer-menu:lx2300'),
                        icon: 'doc',
                        prg: 'C_LX2300',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:lx2035'),
                        icon: 'doc',
                        prg: 'C_LX2035',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:lx215010'),
                        icon: 'doc',
                        prg: 'C_LX215010',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:lx1005'),
                        icon: 'doc',
                        prg: 'C_LX1005',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:lx102001'),
                        icon: 'doc',
                        prg: 'C_LX102001',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:lx102003'),
                        icon: 'doc',
                        prg: 'C_LX102003',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:lx102002'),
                        icon: 'doc',
                        prg: 'C_LX102002',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:lx200101'),
                        icon: 'doc',
                        prg: 'C_LX200101',
                        favorite: false,
                    },
                    {
                        path: '/ix2014',
                        text: t('drawer-menu:ix2014'),
                        icon: 'doc',
                        prg: 'C_IX2014',
                        favorite: false,
                    },
                    {
                        path: '/ix2013',
                        text: t('drawer-menu:ix2013'),
                        icon: 'doc',
                        prg: 'C_IX2013',
                        favorite: false,
                    },
                    {
                        path: '/lx107129',
                        text: t('drawer-menu:lx107129'),
                        icon: 'doc',
                        prg: 'C_LX107129',
                        favorite: false,
                    },
                    {
                        path: '/xspgetzlgtlrz-page',
                        text: t('drawer-menu:lx20011'),
                        icon: 'doc',
                        prg: 'C_LX20011',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:lx200120'),
                        icon: 'doc',
                        prg: 'C_LX200120',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:lx200116'),
                        icon: 'doc',
                        prg: 'C_LX200116',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:lx200130'),
                        icon: 'doc',
                        prg: 'C_LX200130',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:lx200140'),
                        icon: 'doc',
                        prg: 'C_LX200140',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:lx204402'),
                        icon: 'doc',
                        prg: 'C_LX204402',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:lx240003'),
                        icon: 'doc',
                        prg: 'C_LX240003',
                        favorite: false,
                    },
                ]
            },
            {
                path: '#Stammdaten-Druck#',
                text: t('drawer-menu:DR1000'),
                icon: 'print',
                prg: 'C_DR1000',
                favorite: false,
                items: [
                    {
                        path: '/inactive',
                        text: t('drawer-menu:lx109041'),
                        icon: 'doc',
                        prg: 'C_LX109041',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:lx117235'),
                        icon: 'doc',
                        prg: 'C_LX117235',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:lx11729'),
                        icon: 'doc',
                        prg: 'C_LX11729',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:lx107135'),
                        icon: 'doc',
                        prg: 'C_LX107135',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:lx1002'),
                        icon: 'doc',
                        prg: 'C_LX1002',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:lx101003'),
                        icon: 'doc',
                        prg: 'C_LX101003',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:lx20401'),
                        icon: 'doc',
                        prg: 'C_LX20401',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:lx11723'),
                        icon: 'doc',
                        prg: 'C_LX11723',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:lx200085'),
                        icon: 'doc',
                        prg: 'C_LX200085',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:lx1061'),
                        icon: 'doc',
                        prg: 'C_LX1061',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:lx200010'),
                        icon: 'doc',
                        prg: 'C_LX200010',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:lx107050'),
                        icon: 'doc',
                        prg: 'C_LX107050',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:lx1055'),
                        icon: 'doc',
                        prg: 'C_LX1055',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:lx1040'),
                        icon: 'doc',
                        prg: 'C_LX1040',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:lx107002'),
                        icon: 'doc',
                        prg: 'C_LX107002',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:lx107122'),
                        icon: 'doc',
                        prg: 'C_LX107122',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:lx107102'),
                        icon: 'doc',
                        prg: 'C_LX107102',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:lx107101'),
                        icon: 'doc',
                        prg: 'C_LX107101',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:lx1047'),
                        icon: 'doc',
                        prg: 'C_LX1047',
                        favorite: false,
                    },
                    {
                        path: '/lx107106',
                        qParams: 'ds=Berichtscenter',
                        text: t('drawer-menu:lx107106'),
                        icon: 'flaticon flaticon-deal',
                        prg: 'C_LX107106',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:lx107103'),
                        icon: 'doc',
                        prg: 'C_LX107103',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:lx107123'),
                        icon: 'doc',
                        prg: 'C_LX107123',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:lx107128'),
                        icon: 'doc',
                        prg: 'C_LX107128',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:lx107120'),
                        icon: 'doc',
                        prg: 'C_LX107120',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:lx107118'),
                        icon: 'doc',
                        prg: 'C_LX107118',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:ix2011'),
                        icon: 'doc',
                        prg: 'C_IX2011',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:lx107104'),
                        icon: 'doc',
                        prg: 'C_LX107104',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:lx107108'),
                        icon: 'doc',
                        prg: 'C_LX107108',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:lx107109'),
                        icon: 'doc',
                        prg: 'C_LX107109',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:lx107110'),
                        icon: 'doc',
                        prg: 'C_LX107110',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:lx11722'),
                        icon: 'doc',
                        prg: 'C_LX11722',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:lx11725'),
                        icon: 'doc',
                        prg: 'C_LX11725',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:lx107113'),
                        icon: 'doc',
                        prg: 'C_LX107113',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:lx1021'),
                        icon: 'doc',
                        prg: 'C_LX1021',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:lx107105'),
                        icon: 'doc',
                        prg: 'C_LX107105',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:lx1001'),
                        icon: 'doc',
                        prg: 'C_LX1001',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:lx1003'),
                        icon: 'doc',
                        prg: 'C_LX1003',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:lx1006'),
                        icon: 'doc',
                        prg: 'C_LX1006',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:lx1090'),
                        icon: 'doc',
                        prg: 'C_LX1090',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:lx107232'),
                        icon: 'doc',
                        prg: 'C_LX107232',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:lx103002'),
                        icon: 'doc',
                        prg: 'C_LX103002',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:lx40604'),
                        icon: 'doc',
                        prg: 'C_LX40604',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:lx40606'),
                        icon: 'doc',
                        prg: 'C_LX40606',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:lx40600'),
                        icon: 'doc',
                        prg: 'C_LX40600',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:lx40609'),
                        icon: 'doc',
                        prg: 'C_LX40609',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:lx107049'),
                        icon: 'doc',
                        prg: 'C_LX107049',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:lx107055'),
                        icon: 'doc',
                        prg: 'C_LX107055',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:lx107115'),
                        icon: 'doc',
                        prg: 'C_LX107115',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:lx1071041'),
                        icon: 'doc',
                        prg: 'C_LX1071041',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:lx1082'),
                        icon: 'doc',
                        prg: 'C_LX1082',
                        favorite: false,
                    },
                ]
            },
            {
                path: '/inactive',
                text: t('drawer-menu:ixReport'),
                icon: 'doc',
                prg: 'C_IXREPORT',
                favorite: false,
            },
            {
                path: '/inactive',
                text: t('drawer-menu:ixReportStart'),
                icon: 'doc',
                prg: 'C_IXREPORTSTART',
                favorite: false,
            },
            {
                path: '#Excel-Berichte#',
                text: t('drawer-menu:M_58'),
                icon: 'doc',
                prg: 'M_58',
                favorite: false,
                items: [
                    {
                        path: '/inactive',
                        text: t('drawer-menu:ixExcelReport'),
                        icon: 'doc',
                        prg: 'C_IXEXCELREPORT',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:ixGbdReport'),
                        icon: 'doc',
                        prg: 'C_IXGBDREPORT',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:ixTenancyS2'),
                        icon: 'doc',
                        prg: 'C_IXTENANCYS2',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:ixOpMieter'),
                        icon: 'doc',
                        prg: 'C_IXOPMIETER',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:ixVtgHist'),
                        icon: 'doc',
                        prg: 'C_IXVTGHIST',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:ixKautionReport'),
                        icon: 'doc',
                        prg: 'C_IXKAUTIONREPORT',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:ixTranslationMaps'),
                        icon: 'doc',
                        prg: 'C_IXTRANSLATIONMAPS',
                        favorite: false,
                    },
                ]
            },
            {
                path: '/inactive',
                text: t('drawer-menu:ixExcel2DbDlg'),
                icon: 'doc',
                prg: 'C_IXEXCEL2DBDLG',
                favorite: false,
            },
            {
                path: '/inactive',
                text: t('drawer-menu:NCrem_BL@DynTab'),
                icon: 'doc',
                prg: 'C_..\\NURIS\\NCREM.BL@DYNTAB',
                favorite: false,
            },
        ]
    },
    {
        path: '#Wirtschaftsplan#',
        text: t('drawer-menu:M_4'),
        icon: 'doc',
        prg: 'M_4',
        favorite: false,
        items: [
            {
                path: '/inactive',
                text: t('drawer-menu:ix4050'),
                icon: 'doc',
                prg: 'C_IX4050',
                favorite: false,
            },
            {
                path: '/inactive',
                text: t('drawer-menu:ix4052'),
                icon: 'doc',
                prg: 'C_IX4052',
                favorite: false,
            },
            {
                path: '/inactive',
                text: t('drawer-menu:ix409001'),
                icon: 'doc',
                prg: 'C_IX409001',
                favorite: false,
            },
            {
                path: '/inactive',
                text: t('drawer-menu:IX4015'),
                icon: 'doc',
                prg: 'C_IX4015',
                favorite: false,
            },
            {
                path: '/inactive',
                text: t('drawer-menu:IX4016'),
                icon: 'doc',
                prg: 'C_IX4016',
                favorite: false,
            },
            {
                path: '/inactive',
                text: t('drawer-menu:IX40301'),
                icon: 'doc',
                prg: 'C_IX40301',
                favorite: false,
            },
        ]
    },
    {
        path: '#Dienstprogramme#',
        text: t('drawer-menu:M_6'),
        icon: 'doc',
        prg: 'M_6',
        favorite: false,
        items: [
            {
                path: '/inactive',
                text: t('drawer-menu:ix7100'),
                icon: 'doc',
                prg: 'C_IX7100',
                favorite: false,
            },
            {
                path: '/inactive',
                text: t('drawer-menu:ixtext'),
                icon: 'doc',
                prg: 'C_IXTEXT',
                favorite: false,
            },
            {
                path: '/inactive',
                text: t('drawer-menu:ix1035'),
                icon: 'doc',
                prg: 'C_IX1035',
                favorite: false,
            },
            {
                path: '/inactive',
                text: t('drawer-menu:ix1039'),
                icon: 'doc',
                prg: 'C_IX1039',
                favorite: false,
            },
            {
                path: '#Jahresübernahme#',
                text: t('drawer-menu:M_18'),
                icon: 'doc',
                prg: 'M_18',
                favorite: false,
                items: [
                    {
                        path: '/inactive',
                        text: t('drawer-menu:ix800001'),
                        icon: 'doc',
                        prg: 'C_IX800001',
                        favorite: false,
                    },
                    {
                        path: '#Saldovorträge#',
                        text: t('drawer-menu:M_19'),
                        icon: 'doc',
                        prg: 'M_19',
                        favorite: false,
                        items: [
                            {
                                path: '#SAVO-Sachkonten#',
                                text: t('drawer-menu:M_21'),
                                icon: 'doc',
                                prg: 'M_21',
                                favorite: false,
                                items: [
                                    {
                                        path: '/inactive',
                                        text: t('drawer-menu:ix800008'),
                                        icon: 'doc',
                                        prg: 'C_IX800008',
                                        favorite: false,
                                    },
                                    {
                                        path: '/inactive',
                                        text: t('drawer-menu:ix800007'),
                                        icon: 'doc',
                                        prg: 'C_IX800007',
                                        favorite: false,
                                    },
                                    {
                                        path: '/inactive',
                                        text: t('drawer-menu:ix800002'),
                                        icon: 'doc',
                                        prg: 'C_IX800002',
                                        favorite: false,
                                    },
                                ]
                            },
                            {
                                path: '/inactive',
                                text: t('drawer-menu:ix800023'),
                                icon: 'doc',
                                prg: 'C_IX800023',
                                favorite: false,
                            },
                            {
                                path: '/inactive',
                                text: t('drawer-menu:ix800021'),
                                icon: 'doc',
                                prg: 'C_IX800021',
                                favorite: false,
                            },
                            {
                                path: '/inactive',
                                text: t('drawer-menu:ix800025'),
                                icon: 'doc',
                                prg: 'C_IX800025',
                                favorite: false,
                            },
                        ]
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:ix2150'),
                        icon: 'doc',
                        prg: 'C_IX2150',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:ix8009'),
                        icon: 'doc',
                        prg: 'C_IX8009',
                        favorite: false,
                    },
                ]
            },
            {
                path: '#Schnittstellen#',
                text: t('drawer-menu:M_42'),
                icon: 'doc',
                prg: 'M_42',
                favorite: false,
                items: [
                    {
                        path: '/inactive',
                        text: t('drawer-menu:ixfhkd'),
                        icon: 'doc',
                        prg: 'C_IXFHKD',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:NCrem_BL@Heizkosten'),
                        icon: 'doc',
                        prg: 'C_..\\NURIS\\NCREM.BL@HEIZKOSTEN',
                        favorite: false,
                    },
                    {
                        path: '#DATEV-Schnittstelle#',
                        text: t('drawer-menu:M_52'),
                        icon: 'doc',
                        prg: 'M_52',
                        favorite: false,
                        items: [
                            {
                                path: '/inactive',
                                text: t('drawer-menu:ixdatevconfig'),
                                icon: 'doc',
                                prg: 'C_IXDATEVCONFIG',
                                favorite: false,
                            },
                            {
                                path: '/ixdatevex',
                                text: t('drawer-menu:ixdatevex'),
                                icon: 'doc',
                                prg: 'C_IXDATEVEX',
                                favorite: false,
                            },
                            {
                                path: '/inactive',
                                text: t('drawer-menu:ixDatevGvc001Import'),
                                icon: 'doc',
                                prg: 'C_IXDATEVGVC001IMPORT',
                                favorite: false,
                            },
                            {
                                path: '/inactive',
                                text: t('drawer-menu:ixDatevRechnungsImport'),
                                icon: 'doc',
                                prg: 'C_IXDATEVRECHNUNGSIMPORT',
                                favorite: false,
                            },
                            {
                                path: '/inactive',
                                text: t('drawer-menu:lxdatev01'),
                                icon: 'doc',
                                prg: 'C_LXDATEV01',
                                favorite: false,
                            },
                            {
                                path: '/inactive',
                                text: t('drawer-menu:lxdatev02'),
                                icon: 'doc',
                                prg: 'C_LXDATEV02',
                                favorite: false,
                            },
                            {
                                path: '/inactive',
                                text: t('drawer-menu:lxdatev03'),
                                icon: 'doc',
                                prg: 'C_LXDATEV03',
                                favorite: false,
                            },
                        ]
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:ix2900'),
                        icon: 'doc',
                        prg: 'C_IX2900',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:NCrem_CsvReporter@GoBD'),
                        icon: 'doc',
                        prg: 'C_..\\NURIS\\NCREM.CSVREPORTER@GOBD',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:ix2000imp'),
                        icon: 'doc',
                        prg: 'C_IX2000IMP',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:iximportGvc701'),
                        icon: 'doc',
                        prg: 'C_IXIMPORTGVC701',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:ixstdbuexport'),
                        icon: 'doc',
                        prg: 'C_IXSTDBUEXPORT',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:ix2000hndl'),
                        icon: 'doc',
                        prg: 'C_IX2000HNDL',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:ixDepositKMmodul'),
                        icon: 'doc',
                        prg: 'C_IXDEPOSITKMMODUL',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:ixMieterportal'),
                        icon: 'doc',
                        prg: 'C_IXMIETERPORTAL',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:ixebilanz'),
                        icon: 'doc',
                        prg: 'C_IXEBILANZ',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:ixBuExportTool'),
                        icon: 'doc',
                        prg: 'C_IXBUEXPORTTOOL',
                        favorite: false,
                    },
                    {
                        path: '/kxbisonbox',
                        text: t('drawer-menu:kxbisonbox'),
                        icon: 'doc',
                        prg: 'C_KXBISONBOX',
                        favorite: false,
                    },
                    {
                        path: '/kxbuuserinfoexp',
                        text: t('drawer-menu:kxbuuserinfoexp'),
                        icon: 'doc',
                        prg: 'C_KXBUUSERINFOEXP',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:ixRevcExport'),
                        icon: 'doc',
                        prg: 'C_IXREVCEXPORT',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:ixSemPpmBuExp'),
                        icon: 'doc',
                        prg: 'C_IXSEMPPMBUEXP',
                        favorite: false,
                    },
                    {
                        path: '/ixhansainveststdbuexp',
                        text: t('drawer-menu:ixhansainveststdbuexp'),
                        icon: 'doc',
                        prg: 'C_IXHANSAINVESTSTDBUEXP',
                        favorite: false,
                    },
                    {
                        path: '#Zensus#',
                        text: t('drawer-menu:M_80'),
                        icon: 'doc',
                        prg: 'M_80',
                        favorite: false,
                        items: [
                            {
                                path: '/inactive',
                                text: t('drawer-menu:ixgebaeude'),
                                icon: 'doc',
                                prg: 'C_IXGEBAEUDE',
                                favorite: false,
                            },
                            {
                                path: '/inactive',
                                text: t('drawer-menu:zensuswohnung'),
                                icon: 'doc',
                                prg: 'C_ZENSUSWOHNUNG',
                                favorite: false,
                            },
                            {
                                path: '/inactive',
                                text: t('drawer-menu:ixeigentuemerliste'),
                                icon: 'doc',
                                prg: 'C_IXEIGENTUEMERLISTE',
                                favorite: false,
                            },
                            {
                                path: '/inactive',
                                text: t('drawer-menu:kxZensusEx'),
                                icon: 'doc',
                                prg: 'C_KXZENSUSEX',
                                favorite: false,
                            },
                            {
                                path: '#Zensus Premium#',
                                text: t('drawer-menu:M_81'),
                                icon: 'doc',
                                prg: 'M_81',
                                favorite: false,
                                items: [
                                    {
                                        path: '/inactive',
                                        text: t('drawer-menu:NCrem_BL@ZensusGebaeude'),
                                        icon: 'doc',
                                        prg: 'C_..\\NURIS\\NCREM.BL@ZENSUSGEBAEUDE',
                                        favorite: false,
                                    },
                                    {
                                        path: '/inactive',
                                        text: t('drawer-menu:NCrem_BL@ZensusWohnung'),
                                        icon: 'doc',
                                        prg: 'C_..\\NURIS\\NCREM.BL@ZENSUSWOHNUNG',
                                        favorite: false,
                                    },
                                    {
                                        path: '/inactive',
                                        text: t('drawer-menu:NCrem_BL@ZensusNeuEigentumer'),
                                        icon: 'doc',
                                        prg: 'C_..\\NURIS\\NCREM.BL@ZENSUSNEUEIGENTUMER',
                                        favorite: false,
                                    },
                                ]
                            },
                        ]
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:xxxxxx'),
                        icon: 'doc',
                        prg: 'C_XXXXXX',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:M_30'),
                        icon: 'doc',
                        prg: 'M_30',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:xxxxxx'),
                        icon: 'doc',
                        prg: 'C_XXXXXX',
                        favorite: false,
                    },
                    {
                        path: '/kxtrassetsexp',
                        text: t('drawer-menu:kxtrassetsexp'),
                        icon: 'doc',
                        prg: 'C_KXTRASSETSEXP',
                        favorite: false,
                    },
                ]
            },
            {
                path: '#Hilfsprogramme#',
                text: t('drawer-menu:DR6000'),
                icon: 'doc',
                prg: 'C_DR6000',
                favorite: false,
                items: [
                    {
                        path: '/inactive',
                        text: t('drawer-menu:ix20008re'),
                        icon: 'doc',
                        prg: 'C_IX20008RE',
                        favorite: false,
                    },
                ]
            },
            {
                path: '/inactive',
                text: t('drawer-menu:M_29'),
                icon: 'doc',
                prg: 'M_29',
                favorite: false,
            },
            {
                path: '#Zusatzprogramme#',
                text: t('drawer-menu:M_10'),
                icon: 'doc',
                prg: 'M_10',
                favorite: false,
                items: [
                    {
                        path: '/inactive',
                        text: t('drawer-menu:ixMieterportal'),
                        icon: 'doc',
                        prg: 'C_IXMIETERPORTAL',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:ixRevcExport'),
                        icon: 'doc',
                        prg: 'C_IXREVCEXPORT',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:ixRevcExportt'),
                        icon: 'doc',
                        prg: 'C_IXREVCEXPORTT',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:kx584be'),
                        icon: 'doc',
                        prg: 'C_KX584BE',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:ixRevcExport'),
                        icon: 'doc',
                        prg: 'C_IXREVCEXPORT',
                        favorite: false,
                    },
                    {
                        path: '/ixintrealsapbuexp',
                        text: t('drawer-menu:ixintrealsapbuexp'),
                        icon: 'doc',
                        prg: 'C_IXINTREALSAPBUEXP',
                        favorite: false,
                    },
                    {
                        path: '/kx0224sapbuexp',
                        text: t('drawer-menu:kx0224sapbuexp'),
                        icon: 'doc',
                        prg: 'C_KX0224SAPBUEXP',
                        favorite: false,
                    },
                    {
                        path: '/kxtrinitybuexp',
                        text: t('drawer-menu:kxtrinitybuexp'),
                        icon: 'doc',
                        prg: 'C_KXTRINITYBUEXP',
                        favorite: false,
                    },
                    {
                        path: '/kxbnpsapbuexp',
                        text: t('drawer-menu:kxbnpsapbuexp'),
                        icon: 'doc',
                        prg: 'C_KXBNPSAPBUEXP',
                        favorite: false,
                    },
                ]
            },
        ]
    },
    {
        path: '#Meldungen#',
        text: t('drawer-menu:M_Meldungen'),
        icon: 'ix-icon icon-new_meldungen1',
        prg: 'M_MELDUNGEN',
        favorite: true,
        items: [
            {
                path: '/Meldung',
                text: t('drawer-menu:Meldung'),
                icon: 'ix-icon icon-new_meldungen1',
                prg: 'C_..\\NURIS\\NCREM.NURIS.MELDUNG',
                favorite: false,
            },
            {
                path: '#Katalog#',
                text: t('drawer-menu:M_Meldungen_Katalog'),
                icon: 'ix-icon icon-new_catalog',
                prg: 'M_MELDUNGEN_KATALOG',
                favorite: false,
                items: [
                    {
                        path: '/MeldungsArt',
                        text: t('drawer-menu:MeldungsArt'),
                        icon: 'plus',
                        prg: 'C_..\\NURIS\\NCREM.NURIS.MELDUNGSART',
                        favorite: false,
                    },
                    {
                        path: '/MeldungsArtKlasse',
                        text: t('drawer-menu:MeldungsArtKlasse'),
                        icon: 'plus',
                        prg: 'C_..\\NURIS\\NCREM.NURIS.MELDUNGSARTKLASSE',
                        favorite: false,
                    },
                    {
                        path: '/MeldungPrio',
                        text: t('drawer-menu:MeldungPrio'),
                        icon: 'plus',
                        prg: 'C_..\\NURIS\\NCREM.NURIS.MELDUNGPRIO',
                        favorite: false,
                    },
                    {
                        path: '/MeldungStatusArt',
                        text: t('drawer-menu:MeldungStatusArt'),
                        icon: 'plus',
                        prg: 'C_..\\NURIS\\NCREM.NURIS.MELDUNGSTATUSART',
                        favorite: false,
                    },
                    {
                        path: '/MeldungHinweis',
                        text: t('drawer-menu:MeldungHinweis'),
                        icon: 'ix-icon icon-new_catalog',
                        prg: 'C_..\\NURIS\\NCREM.NURIS.MELDUNGHINWEIS',
                        favorite: false,
                    },
                    {
                        path: '/MeldungHinweis3',
                        text: t('drawer-menu:MeldungHinweis3'),
                        icon: 'plus',
                        prg: 'C_..\\NURIS\\NCREM.NURIS.MELDUNGHINWEIS3',
                        favorite: false,
                    },
                    {
                        path: '/MeldungVersFall',
                        text: t('drawer-menu:MeldungVersFall'),
                        icon: 'plus',
                        prg: 'C_..\\NURIS\\NCREM.NURIS.MELDUNGVERSFALL',
                        favorite: false,
                    },
                    {
                        path: '/MeldungVersFallGwrk',
                        text: t('drawer-menu:MeldungVersFallGwrk'),
                        icon: 'plus',
                        prg: 'C_..\\NURIS\\NCREM.NURIS.MELDUNGVERSFALLGWRK',
                        favorite: false,
                    },
                ]
            },
        ]
    },
    {
        path: '#Aufträge#',
        text: t('drawer-menu:Aufträge'),
        icon: 'ix-icon icon-new_auftraege',
        prg: 'M_85',
        favorite: true,
        items: [
            {
                path: '/Auftrag',
                text: t('drawer-menu:Auftrag'),
                icon: 'ix-icon icon-new_auftraege',
                prg: 'C_..\\NURIS\\NCREM.NURIS.AUFTRAG',
                favorite: false,
            },
            {
                path: '/AuftragTermin',
                text: t('drawer-menu:AuftragTermin'),
                icon: 'ix-icon icon-new_termine1',
                prg: 'C_..\\NURIS\\NCREM.NURIS.AUFTRAGTERMIN',
                favorite: false,
            },
            {
                path: '#Katalog#',
                text: t('drawer-menu:Katalog'),
                icon: 'ix-icon icon-new_catalog',
                prg: 'M_86',
                favorite: false,
                items: [
                    {
                        path: '/AuftragsArt',
                        text: t('drawer-menu:AuftragsArt'),
                        icon: 'ix-icon icon-new_catalog',
                        prg: 'C_..\\NURIS\\NCREM.NURIS.AUFTRAG\\AUFTRAGSART',
                        favorite: false,
                    },
                    {
                        path: '/AuftragsArtKlasse',
                        text: t('drawer-menu:AuftragsArtKlasse'),
                        icon: 'ix-icon icon-new_catalog',
                        prg: 'C_..\\NURIS\\NCREM.NURIS.AUFTRAG\\AUFTRAGSARTKLASSE',
                        favorite: false,
                    },
                    {
                        path: '/AuftragPrio',
                        text: t('drawer-menu:AuftragPrio'),
                        icon: 'ix-icon icon-new_catalog',
                        prg: 'C_..\\NURIS\\NCREM.NURIS.AUFTRAG\\AUFTRAGPRIO',
                        favorite: false,
                    },
                    {
                        path: '/AuftragHinweis',
                        text: t('drawer-menu:AuftragHinweis'),
                        icon: 'ix-icon icon-new_catalog',
                        prg: 'C_..\\NURIS\\NCREM.NURIS.AUFTRAG\\AUFTRAGHINWEIS',
                        favorite: false,
                    },
                    {
                        path: '/AuftragsStatusArt',
                        text: t('drawer-menu:AuftragsStatusArt'),
                        icon: 'ix-icon icon-new_catalog',
                        prg: 'C_..\\NURIS\\NCREM.NURIS.AUFTRAG\\AUFTRAGSSTATUSART',
                        favorite: false,
                    },
                    {
                        path: '/GenehmigungsDefinition',
                        text: t('drawer-menu:GenehmigungsDefinition'),
                        icon: 'ix-icon icon-genehmigungdefinition',
                        prg: 'C_..\\NURIS\\NCREM.NURIS.AUFTRAG\\GENEHMIGUNGSDEFINITION',
                        favorite: false,
                    },
                    {
                        path: '/LeistungsArt',
                        text: t('drawer-menu:LeistungsArt'),
                        icon: 'ix-icon icon-new_catalog',
                        prg: 'C_..\\NURIS\\NCREM.NURIS.AUFTRAG\\LEISTUNGSART',
                        favorite: false,
                    },
                    {
                        path: '/LeistungsVerzeichnis',
                        text: t('drawer-menu:LeistungsVerzeichnis'),
                        icon: 'ix-icon icon-new_catalog',
                        prg: 'C_..\\NURIS\\NCREM.NURIS.AUFTRAG\\LEISTUNGSVERZEICHNIS',
                        favorite: false,
                    },
                    {
                        path: '/GwSicherungsArt',
                        text: t('drawer-menu:GwSicherungsArt'),
                        icon: 'ix-icon icon-new_catalog',
                        prg: 'C_..\\NURIS\\NCREM.NURIS.AUFTRAG\\GWSICHERUNGSART',
                        favorite: false,
                    },
                    {
                        path: '/GwSicherungsStatus',
                        text: t('drawer-menu:GwSicherungsStatus'),
                        icon: 'ix-icon icon-new_catalog',
                        prg: 'C_..\\NURIS\\NCREM.NURIS.AUFTRAG\\GWSICHERUNGSSTATUS',
                        favorite: false,
                    },
                    {
                        path: '/GwMaengelStatus',
                        text: t('drawer-menu:GwMaengelStatus'),
                        icon: 'ix-icon icon-new_catalog',
                        prg: 'C_..\\NURIS\\NCREM.NURIS.AUFTRAG\\GWMAENGELSTATUS',
                        favorite: false,
                    },
                    {
                        path: '/LieferBedingung',
                        text: t('drawer-menu:LieferBedingung'),
                        icon: 'ix-icon icon-new_catalog',
                        prg: 'C_..\\NURIS\\NCREM.NURIS.AUFTRAG\\LIEFERBEDINGUNG',
                        favorite: false,
                    },
                    {
                        path: '/ZahlungsBedingung',
                        text: t('drawer-menu:ZahlungsBedingung'),
                        icon: 'ix-icon icon-new_catalog',
                        prg: 'C_..\\NURIS\\NCREM.NURIS.AUFTRAG\\ZAHLUNGSBEDINGUNG',
                        favorite: false,
                    },
                ]
            },
        ]
    },
    {
        path: '#Technische Objekte#',
        text: t('drawer-menu:Technische Objekte'),
        icon: 'plus',
        prg: 'M_87',
        favorite: false,
        items: [
            {
                path: '/TO',
                text: t('drawer-menu:TO'),
                icon: 'ix-icon icon-to',
                prg: 'C_..\\NURIS\\NCREM.NURIS.TO',
                favorite: false,
            },
            {
                path: '#Katalog#',
                text: t('drawer-menu:Katalog'),
                icon: 'plus',
                prg: 'M_88',
                favorite: false,
                items: [
                    {
                        path: '/TODef',
                        text: t('drawer-menu:TODef'),
                        icon: 'ix-icon icon-new_catalog',
                        prg: 'C_..\\NURIS\\NCREM.NURIS.TO\\TODEF',
                        favorite: false,
                    },
                    {
                        path: '/TOPruefungsart',
                        text: t('drawer-menu:TOPruefungsart'),
                        icon: 'ix-icon icon-new_catalog',
                        prg: 'C_..\\NURIS\\NCREM.NURIS.TO\\TOPRUEFUNGSART',
                        favorite: false,
                    },
                    {
                        path: '/TOHersteller',
                        text: t('drawer-menu:TOHersteller'),
                        icon: 'ix-icon icon-new_catalog',
                        prg: 'C_..\\NURIS\\NCREM.NURIS.TO\\TOHERSTELLER',
                        favorite: false,
                    },
                    {
                        path: '/TOGesundheitsamt',
                        text: t('drawer-menu:TOGesundheitsamt'),
                        icon: 'ix-icon icon-new_catalog',
                        prg: 'C_..\\NURIS\\NCREM.NURIS.TO\\TOGESUNDHEITSAMT',
                        favorite: false,
                    },
                    {
                        path: '/TORechtsgrundlagen',
                        text: t('drawer-menu:TORechtsgrundlagen'),
                        icon: 'ix-icon icon-new_catalog',
                        prg: 'C_..\\NURIS\\NCREM.NURIS.TO\\TORECHTSGRUNDLAGEN',
                        favorite: false,
                    },
                ]
            },
        ]
    },
    {
        path: '#iX-Haus plus#',
        text: t('drawer-menu:M_67'),
        icon: 'doc',
        prg: 'M_67',
        favorite: false,
        items: [
            {
                path: '#IHS#',
                text: t('drawer-menu:M_68'),
                icon: 'doc',
                prg: 'M_68',
                favorite: false,
                items: [
                    {
                        path: '/inactive',
                        text: t('drawer-menu:NCrem_Nuris_Angebot'),
                        icon: 'doc',
                        prg: 'C_..\\NURIS\\NCREM.NURIS.ANGEBOT',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:NCrem_Nuris_TO@Zaehler'),
                        icon: 'doc',
                        prg: 'C_..\\NURIS\\NCREM.NURIS.TO@ZAEHLER',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:NCrem_Nuris_TO@Energieausweis'),
                        icon: 'doc',
                        prg: 'C_..\\NURIS\\NCREM.NURIS.TO@ENERGIEAUSWEIS',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:NCrem_Nuris_Vertrag'),
                        icon: 'doc',
                        prg: 'C_..\\NURIS\\NCREM.NURIS.VERTRAG',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:NCrem_Sicherheiten'),
                        icon: 'doc',
                        prg: 'C_..\\NURIS\\NCREM.SICHERHEITEN',
                        favorite: false,
                    },
                ]
            },
            {
                path: '#Partner#',
                text: t('drawer-menu:M_74'),
                icon: 'doc',
                prg: 'M_74',
                favorite: false,
                items: [
                    {
                        path: '/inactive',
                        text: t('drawer-menu:NCrem_BL@GavPersonView'),
                        icon: 'doc',
                        prg: 'C_..\\NURIS\\NCREM.BL@GAVPERSONVIEW',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:NCrem_BL@GavUnternehmenView'),
                        icon: 'doc',
                        prg: 'C_..\\NURIS\\NCREM.BL@GAVUNTERNEHMENVIEW',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:NCrem_BL@GavUnternehmenNiederlassungen'),
                        icon: 'doc',
                        prg: 'C_..\\NURIS\\NCREM.BL@GAVUNTERNEHMENNIEDERLASSUNGEN',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:NCrem_BL@GavPartnerView'),
                        icon: 'doc',
                        prg: 'C_..\\NURIS\\NCREM.BL@GAVPARTNERVIEW',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:NCrem_BL@GavIxPersonView'),
                        icon: 'doc',
                        prg: 'C_..\\NURIS\\NCREM.BL@GAVIXPERSONVIEW',
                        favorite: false,
                    },
                    {
                        path: '#Rollen#',
                        text: t('drawer-menu:M_75'),
                        icon: 'doc',
                        prg: 'M_75',
                        favorite: false,
                        items: [
                            {
                                path: '/inactive',
                                text: t('drawer-menu:NCrem_BL@GavMieterView'),
                                icon: 'doc',
                                prg: 'C_..\\NURIS\\NCREM.BL@GAVMIETERVIEW',
                                favorite: false,
                            },
                            {
                                path: '/inactive',
                                text: t('drawer-menu:NCrem_BL@GavMitgliedView'),
                                icon: 'doc',
                                prg: 'C_..\\NURIS\\NCREM.BL@GAVMITGLIEDVIEW',
                                favorite: false,
                            },
                            {
                                path: '/inactive',
                                text: t('drawer-menu:NCrem_BL@GavWEGEigentuemerView'),
                                icon: 'doc',
                                prg: 'C_..\\NURIS\\NCREM.BL@GAVWEGEIGENTUEMERVIEW',
                                favorite: false,
                            },
                            {
                                path: '/inactive',
                                text: t('drawer-menu:NCrem_BL@GavSEVAuftraggeberView'),
                                icon: 'doc',
                                prg: 'C_..\\NURIS\\NCREM.BL@GAVSEVAUFTRAGGEBERVIEW',
                                favorite: false,
                            },
                            {
                                path: '/inactive',
                                text: t('drawer-menu:NCrem_BL@GavVermieterView'),
                                icon: 'doc',
                                prg: 'C_..\\NURIS\\NCREM.BL@GAVVERMIETERVIEW',
                                favorite: false,
                            },
                            {
                                path: '/inactive',
                                text: t('drawer-menu:NCrem_BL@GavObjekteigentuemerView'),
                                icon: 'doc',
                                prg: 'C_..\\NURIS\\NCREM.BL@GAVOBJEKTEIGENTUEMERVIEW',
                                favorite: false,
                            },
                            {
                                path: '/inactive',
                                text: t('drawer-menu:NCrem_BL@GavSchreibenEmpfaengerView'),
                                icon: 'doc',
                                prg: 'C_..\\NURIS\\NCREM.BL@GAVSCHREIBENEMPFAENGERVIEW',
                                favorite: false,
                            },
                            {
                                path: '/inactive',
                                text: t('drawer-menu:NCrem_BL@GavMitarbeiterView'),
                                icon: 'doc',
                                prg: 'C_..\\NURIS\\NCREM.BL@GAVMITARBEITERVIEW',
                                favorite: false,
                            },
                            {
                                path: '/inactive',
                                text: t('drawer-menu:NCrem_BL@GavInteressentView'),
                                icon: 'doc',
                                prg: 'C_..\\NURIS\\NCREM.BL@GAVINTERESSENTVIEW',
                                favorite: false,
                            },
                        ]
                    },
                ]
            },
            {
                path: '/inactive',
                text: t('drawer-menu:NCrem_Plus_Objekte'),
                icon: 'doc',
                prg: 'C_..\\NURIS\\NCREM.PLUS.OBJEKTE',
                favorite: false,
            },
            {
                path: '/inactive',
                text: t('drawer-menu:NCrem_Plus_Objekte@ObjVerantwortlichen'),
                icon: 'doc',
                prg: 'C_..\\NURIS\\NCREM.PLUS.OBJEKTE@OBJVERANTWORTLICHEN',
                favorite: false,
            },
            {
                path: '/inactive',
                text: t('drawer-menu:NCrem_Plus_Flaeche'),
                icon: 'doc',
                prg: 'C_..\\NURIS\\NCREM.PLUS.FLAECHE',
                favorite: false,
            },
            {
                path: '/inactive',
                text: t('drawer-menu:NCrem_Raumbuch'),
                icon: 'doc',
                prg: 'C_..\\NURIS\\NCREM.RAUMBUCH',
                favorite: false,
            },
            {
                path: '/inactive',
                text: t('drawer-menu:NCrem_Plus_Kreditoren'),
                icon: 'doc',
                prg: 'C_..\\NURIS\\NCREM.PLUS.KREDITOREN',
                favorite: false,
            },
            {
                path: '/inactive',
                text: t('drawer-menu:NCrem_Plus_Personen'),
                icon: 'doc',
                prg: 'C_..\\NURIS\\NCREM.PLUS.PERSONEN',
                favorite: false,
            },
            {
                path: '/inactive',
                text: t('drawer-menu:NCrem_Termin'),
                icon: 'doc',
                prg: 'C_..\\NURIS\\NCREM.TERMIN',
                favorite: false,
            },
            {
                path: '/inactive',
                text: t('drawer-menu:NCrem_Plus_Projekt'),
                icon: 'doc',
                prg: 'C_..\\NURIS\\NCREM.PLUS.PROJEKT',
                favorite: false,
            },
            {
                path: '/inactive',
                text: t('drawer-menu:NCrem_Import_Ixhaus'),
                icon: 'doc',
                prg: 'C_..\\NURIS\\NCREM.IMPORT.IXHAUS',
                favorite: false,
            },
            {
                path: '/inactive',
                text: t('drawer-menu:NCrem_BL@DatenschutzRolle'),
                icon: 'doc',
                prg: 'C_..\\NURIS\\NCREM.BL@DATENSCHUTZROLLE',
                favorite: false,
            },
            {
                path: '/inactive',
                text: t('drawer-menu:NCrem_Plus_Sachkonten'),
                icon: 'doc',
                prg: 'C_..\\NURIS\\NCREM.PLUS.SACHKONTEN',
                favorite: false,
            },
            {
                path: '/inactive',
                text: t('drawer-menu:NCrem_BL@Kontoauszug'),
                icon: 'doc',
                prg: 'C_..\\NURIS\\NCREM.BL@KONTOAUSZUG',
                favorite: false,
            },
            {
                path: '/inactive',
                text: t('drawer-menu:NCrem_Erwerberverwaltung'),
                icon: 'doc',
                prg: 'C_..\\NURIS\\NCREM.ERWERBERVERWALTUNG',
                favorite: false,
            },
            {
                path: '/inactive',
                text: t('drawer-menu:NCrem_BL_BusinessObjects_Scheduler'),
                icon: 'doc',
                prg: 'C_..\\NURIS\\NCREM.BL.BUSINESSOBJECTS.SCHEDULER',
                favorite: false,
            },
            {
                path: '/inactive',
                text: t('drawer-menu:NCrem_BL@Flurstuecke'),
                icon: 'doc',
                prg: 'C_..\\NURIS\\NCREM.BL@FLURSTUECKE',
                favorite: false,
            },
            {
                path: '/inactive',
                text: t('drawer-menu:NCrem_BL@GrundsteuerDaten'),
                icon: 'doc',
                prg: 'C_..\\NURIS\\NCREM.BL@GRUNDSTEUERDATEN',
                favorite: false,
            },
            {
                path: '/inactive',
                text: t('drawer-menu:NCrem_BL@Schluesselverwaltung'),
                icon: 'doc',
                prg: 'C_..\\NURIS\\NCREM.BL@SCHLUESSELVERWALTUNG',
                favorite: false,
            },
            {
                path: '/inactive',
                text: t('drawer-menu:NCrem_BL@Mietspiegel'),
                icon: 'doc',
                prg: 'C_..\\NURIS\\NCREM.BL@MIETSPIEGEL',
                favorite: false,
            },
            {
                path: '/inactive',
                text: t('drawer-menu:NCrem_Scheduler@DASI'),
                icon: 'doc',
                prg: 'C_..\\NURIS\\NCREM.SCHEDULER@DASI',
                favorite: false,
            },
        ]
    },
    {
        path: '#Fachadministration#',
        text: t('drawer-menu:M_61'),
        icon: 'doc',
        prg: 'M_61',
        favorite: false,
        items: [
            {
                path: '/inactive',
                text: t('drawer-menu:ixUpdSrvc'),
                icon: 'doc',
                prg: 'C_IXUPDSRVC',
                favorite: false,
            },
            {
                path: '#Administration#',
                text: t('drawer-menu:M_24'),
                icon: 'flaticon flaticon-agreement',
                prg: 'M_24',
                favorite: true,
                items: [
                    {
                        path: '/inactive',
                        text: t('drawer-menu:ixSystemSettings'),
                        icon: 'doc',
                        prg: 'C_IXSYSTEMSETTINGS',
                        favorite: false,
                    },
                    {
                        path: '/settings',
                        text: t('drawer-menu:ixSystemAllgemein'),
                        icon: 'doc',
                        prg: 'C_IXSYSTEMALLGEMEIN',
                        favorite: true,
                    },
                    {
                        path: '/ixadmin',
                        text: t('drawer-menu:ixadmin'),
                        icon: 'doc',
                        prg: 'C/IXADMIN',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:ixSystemRights'),
                        icon: 'doc',
                        prg: 'C_IXSYSTEMRIGHTS',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:ixSystemTeam'),
                        icon: 'doc',
                        prg: 'C_IXSYSTEMTEAM',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:ixSystemUser'),
                        icon: 'doc',
                        prg: 'C_IXSYSTEMUSER',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:NCrem_BL@IxHausUser'),
                        icon: 'doc',
                        prg: 'C_..\\NURIS\\NCREM.BL@IXHAUSUSER',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:ixSystemWerTutWas'),
                        icon: 'doc',
                        prg: 'C_IXSYSTEMWERTUTWAS',
                        favorite: false,
                    },
                ]
            },
            {
                path: '/inactive',
                text: t('drawer-menu:xxxxxx'),
                icon: 'doc',
                prg: 'C_XXXXXX',
                favorite: false,
            },
            {
                path: '/inactive',
                text: t('drawer-menu:ix1023'),
                icon: 'doc',
                prg: 'C_IX1023',
                favorite: false,
            },
            {
                path: '/inactive',
                text: t('drawer-menu:ixadmbsr'),
                icon: 'doc',
                prg: 'C_IXADMBSR',
                favorite: false,
            },
            {
                path: '/inactive',
                text: t('drawer-menu:ixBankDirectory'),
                icon: 'doc',
                prg: 'C_IXBANKDIRECTORY',
                favorite: false,
            },
            {
                path: '/inactive',
                text: t('drawer-menu:IX2600'),
                icon: 'doc',
                prg: 'C_IX2600',
                favorite: false,
            },
            {
                path: '/inactive',
                text: t('drawer-menu:ixBuAdm'),
                icon: 'doc',
                prg: 'C_IXBUADM',
                favorite: false,
            },
            {
                path: '/inactive',
                text: t('drawer-menu:ixBuInfoAdm'),
                icon: 'doc',
                prg: 'C_IXBUINFOADM',
                favorite: false,
            },
            {
                path: '/inactive',
                text: t('drawer-menu:ixdbhist'),
                icon: 'doc',
                prg: 'C_IXDBHIST',
                favorite: false,
            },
            {
                path: '/inactive',
                text: t('drawer-menu:lx1009'),
                icon: 'doc',
                prg: 'C_LX1009',
                favorite: false,
            },
            {
                path: '/inactive',
                text: t('drawer-menu:ixDaypassAdm'),
                icon: 'doc',
                prg: 'C_IXDAYPASSADM',
                favorite: false,
            },
            {
                path: '/inactive',
                text: t('drawer-menu:IX2021'),
                icon: 'doc',
                prg: 'C_IX2021',
                favorite: false,
            },
            {
                path: '#DocuWare-Integration#',
                text: t('drawer-menu:M_65'),
                icon: 'doc',
                prg: 'M_65',
                favorite: false,
                items: [
                    {
                        path: '/inactive',
                        text: t('drawer-menu:dmsMenuDef'),
                        icon: 'doc',
                        prg: 'C_DMSMENUDEF',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:dmsFileDef'),
                        icon: 'doc',
                        prg: 'C_DMSFILEDEF',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:dmsKonfigProt'),
                        icon: 'doc',
                        prg: 'C_DMSKONFIGPROT',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:dmsDocExport'),
                        icon: 'doc',
                        prg: 'C_DMSDOCEXPORT',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:ix1405'),
                        icon: 'doc',
                        prg: 'C_IX1405',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:xxxxxx'),
                        icon: 'doc',
                        prg: 'C_XXXXXX',
                        favorite: false,
                    },
                ]
            },
            {
                path: '/inactive',
                text: t('drawer-menu:ixintercompanyparameter'),
                icon: 'doc',
                prg: 'C_IXINTERCOMPANYPARAMETER',
                favorite: false,
            },
            {
                path: '/inactive',
                text: t('drawer-menu:ixkatalog'),
                icon: 'doc',
                prg: 'C_IXKATALOG',
                favorite: false,
            },
            {
                path: '/inactive',
                text: t('drawer-menu:ixMarkOldData'),
                icon: 'doc',
                prg: 'C_IXMARKOLDDATA',
                favorite: false,
            },
            {
                path: '/inactive',
                text: t('drawer-menu:ixKonfipay'),
                icon: 'doc',
                prg: 'C_IXKONFIPAY',
                favorite: false,
            },
            {
                path: '#Musterdaten#',
                text: t('drawer-menu:M_22'),
                icon: 'doc',
                prg: 'M_22',
                favorite: false,
                items: [
                    {
                        path: '/inactive',
                        text: t('drawer-menu:ix1401'),
                        icon: 'doc',
                        prg: 'C_IX1401',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:ix1472'),
                        icon: 'doc',
                        prg: 'C_IX1472',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:ix1310'),
                        icon: 'doc',
                        prg: 'C_IX1310',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:ix1420'),
                        icon: 'doc',
                        prg: 'C_IX1420',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:ix1421'),
                        icon: 'doc',
                        prg: 'C_IX1421',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:ix4076'),
                        icon: 'doc',
                        prg: 'C_IX4076',
                        favorite: false,
                    },
                ]
            },
            {
                path: '/inactive',
                text: t('drawer-menu:ix1050'),
                icon: 'doc',
                prg: 'C_IX1050',
                favorite: false,
            },
            {
                path: '/inactive',
                text: t('drawer-menu:ixobjend'),
                icon: 'doc',
                prg: 'C_IXOBJEND',
                favorite: false,
            },
            {
                path: '/inactive',
                text: t('drawer-menu:IX1045'),
                icon: 'doc',
                prg: 'C_IX1045',
                favorite: false,
            },
            {
                path: '#Partnerverwaltung#',
                text: t('drawer-menu:M_71'),
                icon: 'doc',
                prg: 'M_71',
                favorite: false,
                items: [
                    {
                        path: '/inactive',
                        text: t('drawer-menu:ixGavSettings'),
                        icon: 'doc',
                        prg: 'C_IXGAVSETTINGS',
                        favorite: false,
                    },
                ]
            },
            {
                path: '/inactive',
                text: t('drawer-menu:NCrem_BL@Interfaces'),
                icon: 'doc',
                prg: 'C_..\\NURIS\\NCREM.BL@INTERFACES',
                favorite: false,
            },
            {
                path: '/inactive',
                text: t('drawer-menu:ScriptmenuDef'),
                icon: 'doc',
                prg: 'C_SCRIPTMENUDEF',
                favorite: false,
            },
            {
                path: '#SEPA#',
                text: t('drawer-menu:M_64'),
                icon: 'doc',
                prg: 'M_64',
                favorite: false,
                items: [
                    {
                        path: '/inactive',
                        text: t('drawer-menu:ixSepaReport'),
                        icon: 'doc',
                        prg: 'C_IXSEPAREPORT',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:ixMarkOldData'),
                        icon: 'doc',
                        prg: 'C_IXMARKOLDDATA',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:ix1036'),
                        icon: 'doc',
                        prg: 'C_IX1036',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:ixSepaNotification'),
                        icon: 'doc',
                        prg: 'C_IXSEPANOTIFICATION',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:ixIbanHinRueck'),
                        icon: 'doc',
                        prg: 'C_IXIBANHINRUECK',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:ixKontoBlzLeer'),
                        icon: 'doc',
                        prg: 'C_IXKONTOBLZLEER',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:ixSepaSetZV'),
                        icon: 'doc',
                        prg: 'C_IXSEPASETZV',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:ixSepaSetMR'),
                        icon: 'doc',
                        prg: 'C_IXSEPASETMR',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:ixEz2Mandat'),
                        icon: 'doc',
                        prg: 'C_IXEZ2MANDAT',
                        favorite: false,
                    },
                ]
            },
            {
                path: '/inactive',
                text: t('drawer-menu:ix30100'),
                icon: 'doc',
                prg: 'C_IX30100',
                favorite: false,
            },
            {
                path: '/inactive',
                text: t('drawer-menu:ix1174'),
                icon: 'doc',
                prg: 'C_IX1174',
                favorite: false,
            },
            {
                path: '/inactive',
                text: t('drawer-menu:ix1175'),
                icon: 'doc',
                prg: 'C_IX1175',
                favorite: false,
            },
            {
                path: '/inactive',
                text: t('drawer-menu:ixtrimahn'),
                icon: 'doc',
                prg: 'C_IXTRIMAHN',
                favorite: false,
            },
            {
                path: '#Umsetzer und Tools#',
                text: t('drawer-menu:M_66'),
                icon: 'doc',
                prg: 'M_66',
                favorite: false,
                items: [
                    {
                        path: '/inactive',
                        text: t('drawer-menu:ixUmbRuecklage'),
                        icon: 'doc',
                        prg: 'C_IXUMBRUECKLAGE',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:ix20009'),
                        icon: 'doc',
                        prg: 'C_IX20009',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:ixDataViewer'),
                        icon: 'doc',
                        prg: 'C_IXDATAVIEWER',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:ixXlsToXlsx'),
                        icon: 'doc',
                        prg: 'C_IXXLSTOXLSX',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:ix200010re'),
                        icon: 'doc',
                        prg: 'C_IX200010RE',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:ix2049'),
                        icon: 'doc',
                        prg: 'C_IX2049',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:ixFlErlmPlanmiete'),
                        icon: 'doc',
                        prg: 'C_IXFLERLMPLANMIETE',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:ix40401'),
                        icon: 'doc',
                        prg: 'C_IX40401',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:ixKreDebTool'),
                        icon: 'doc',
                        prg: 'C_IXKREDEBTOOL',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:ix10722'),
                        icon: 'doc',
                        prg: 'C_IX10722',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:rxcreateperkto'),
                        icon: 'doc',
                        prg: 'C_RXCREATEPERKTO',
                        favorite: false,
                    },
                    {
                        path: '/ix107211',
                        text: t('drawer-menu:ix107211'),
                        icon: 'doc',
                        prg: 'C_IX107211',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:ixcore2cor1'),
                        icon: 'doc',
                        prg: 'C_IXCORE2COR1',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:ixSevUmstellung'),
                        icon: 'doc',
                        prg: 'C_IXSEVUMSTELLUNG',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:resetflbel'),
                        icon: 'doc',
                        prg: 'C_RESETFLBEL',
                        favorite: false,
                    },
                    {
                        path: '/inactive',
                        text: t('drawer-menu:ixVirtKtoTool'),
                        icon: 'doc',
                        prg: 'C_IXVIRTKTOTOOL',
                        favorite: false,
                    },
                    {
                        path: '/ixerechnungready',
                        text: t('drawer-menu:ixerechnungready'),
                        icon: 'doc',
                        prg: 'C_IXERECHNUNGREADY',
                        favorite: false,
                    },
                ]
            },
            {
                path: '/inactive',
                text: t('drawer-menu:ix1038'),
                icon: 'doc',
                prg: 'C_IX1038',
                favorite: false,
            },
            {
                path: '/inactive',
                text: t('drawer-menu:ixProfile'),
                icon: 'doc',
                prg: 'C_IXPROFILE',
                favorite: false,
            },
            {
                path: '/inactive',
                text: t('drawer-menu:ixZinsTabStm'),
                icon: 'doc',
                prg: 'C_IXZINSTABSTM',
                favorite: false,
            },
            {
                path: '/ixWebPrnsrvc',
                text: t('drawer-menu:ixWebPrnsrvc'),
                icon: 'doc',
                prg: 'C_IXWEBPRNSRVC',
                favorite: false,
            },
        ]
    },
    {
        path: '/inactive',
        text: t('drawer-menu:M_49'),
        icon: 'doc',
        prg: 'M_49',
        favorite: false,
    },
    {
        path: '#Vier-Augen-Prinzip#',
        text: t('drawer-menu:M_56'),
        icon: 'doc',
        prg: 'M_56',
        favorite: false,
        items: [
            {
                path: '/inactive',
                text: t('drawer-menu:ix4apCfg'),
                icon: 'doc',
                prg: 'C_IX4APCFG',
                favorite: false,
            },
            {
                path: '/inactive',
                text: t('drawer-menu:ix4apEx'),
                icon: 'doc',
                prg: 'C_IX4APEX',
                favorite: false,
            },
            {
                path: '/inactive',
                text: t('drawer-menu:lx1008'),
                icon: 'doc',
                prg: 'C_LX1008',
                favorite: false,
            },
            {
                path: '/inactive',
                text: t('drawer-menu:lx1008kr'),
                icon: 'doc',
                prg: 'C_LX1008KR',
                favorite: false,
            },
            {
                path: '/inactive',
                text: t('drawer-menu:lx1008flstm'),
                icon: 'doc',
                prg: 'C_LX1008FLSTM',
                favorite: false,
            },
        ]
    },
    {
        path: '#Fremdwährung#',
        text: t('drawer-menu:M_55'),
        icon: 'doc',
        prg: 'M_55',
        favorite: false,
        items: [
            {
                path: '/inactive',
                text: t('drawer-menu:ix1820'),
                icon: 'doc',
                prg: 'C_IX1820',
                favorite: false,
            },
            {
                path: '/inactive',
                text: t('drawer-menu:ix1830'),
                icon: 'doc',
                prg: 'C_IX1830',
                favorite: false,
            },
        ]
    },
    {
        path: '#Listen ohne Mehrwährung#',
        text: t('drawer-menu:M_78'),
        icon: 'doc',
        prg: 'M_78',
        favorite: false,
        items: [
            {
                path: '/inactive',
                text: t('drawer-menu:DX2000'),
                icon: 'doc',
                prg: 'C_DX2000',
                favorite: false,
            },
            {
                path: '/inactive',
                text: t('drawer-menu:DX1000'),
                icon: 'doc',
                prg: 'C_DX1000',
                favorite: false,
            },
        ]
    },
    {
        path: '#Test#',
        text: t('drawer-menu:test'),
        icon: 'flaticon flaticon-agreement',
        prg: '',
        favorite: true,
        items: [
            {
                path: '/account-lookup-form',
                text: t('drawer-menu:accountLookupForm'),
                icon: 'flaticon flaticon-accounting',
                prg: '',
                favorite: true,
            },
            {
                path: '/background-jobs',
                text: t('drawer-menu:backgroundJobs'),
                icon: 'doc',
                prg: '',
                favorite: true,
            },
            {
                path: '/charts',
                text: t('drawer-menu:charts'),
                icon: 'chart',
                prg: '',
                favorite: false,
            },
            {
                path: '/chartsQLik',
                text: t('drawer-menu:chartsQLik'),
                icon: 'chart',
                prg: '',
                favorite: false,
            },
            {
                path: '#GridBenchmark#',
                text: t('drawer-menu:gridBenchmark'),
                icon: 'rowfield',
                prg: '',
                favorite: false,
                items: [
                    {
                        path: '/benchmark',
                        qParams: 'ds=30k',
                        text: t('drawer-menu:benchmarkDatagrid30K'),
                        icon: 'rowfield',
                        prg: '',
                        favorite: false,
                    },
                    {
                        path: '/benchmark',
                        qParams: 'ds=100k',
                        text: t('drawer-menu:benchmarkDatagrid100K'),
                        icon: 'rowfield',
                        prg: '',
                        favorite: false,
                    },
                    {
                        path: '/genbenchmark',
                        text: t('drawer-menu:benchmarkGenerated'),
                        icon: 'rowfield',
                        prg: '',
                        favorite: true,
                    },
                ]
            },
            {
                path: '/test-form',
                text: t('drawer-menu:testForm'),
                icon: 'doc',
                prg: '',
                favorite: true,
            },
            {
                path: '/lookup-test',
                text: t('drawer-menu:lookupTestPage'),
                icon: 'doc',
                prg: '',
                favorite: true,
            },
            {
                path: '/clearing',
                text: t('drawer-menu:clearing'),
                icon: 'doc',
                prg: '',
                favorite: false,
            },
            {
                path: '/budim-test-page',
                text: t('buDim:name.page'),
                icon: 'flaticon flaticon-deal',
                prg: '',
                favorite: false,
            },
            {
                path: '/ktgdim-test-page',
                text: t('ktgDim:name.page'),
                icon: 'flaticon flaticon-deal',
                prg: '',
                favorite: false,
            },
            {
                path: '#Issues#',
                text: t('drawer-menu:issue'),
                icon: 'flaticon flaticon-broken-house',
                prg: '',
                favorite: false,
                items: [
                    {
                        path: '/issues',
                        text: t('drawer-menu:issues'),
                        icon: 'flaticon flaticon-broken-house',
                        prg: '',
                        favorite: false,
                    },
                    {
                        path: '/issues/new',
                        text: t('drawer-menu:newIssueDevextreme'),
                        icon: 'flaticon flaticon-broken-house',
                        prg: '',
                        favorite: false,
                    },
                    {
                        path: '/issues/archive',
                        text: t('drawer-menu:newIssueFormik'),
                        icon: 'flaticon flaticon-broken-house',
                        prg: '',
                        favorite: false,
                    },
                    {
                        path: '/issues/add',
                        text: t('drawer-menu:issueAdd'),
                        icon: 'ix-icon icon-issue-add',
                        prg: '',
                        favorite: true,
                    },
                    {
                        path: '/issues/db',
                        text: t('drawer-menu:issuesGrid'),
                        icon: 'ix-icon icon-issue-grid',
                        prg: '',
                        favorite: true,
                    },
                ]
            },
            {
                path: '#Test1#',
                text: t('drawer-menu:test'),
                icon: 'doc',
                prg: '',
                favorite: false,
                items: [
                    {
                        path: '/contracts',
                        text: t('drawer-menu:contracts'),
                        icon: 'flaticon flaticon-agreement',
                        prg: '',
                        favorite: true,
                    },
                    {
                        path: '/contractsadd',
                        text: t('drawer-menu:contractsAdd'),
                        icon: 'flaticon flaticon-agreement',
                        prg: '',
                        favorite: true,
                    },
                    {
                        path: '/contract-management',
                        text: t('drawer-menu:contractManagement'),
                        icon: 'flaticon flaticon-agreement',
                        prg: '',
                        favorite: true,
                    },
                    {
                        path: '/contract-management-v2',
                        text: t('drawer-menu:contractManagementV2'),
                        icon: 'flaticon flaticon-agreement',
                        prg: '',
                        favorite: true,
                    },
                ]
            },
        ]
    },
    {
        path: '#Unsorted#',
        text: t('Unsorted'),
        icon: 'flaticon flaticon-agreement',
        prg: '',
        favorite: true,
        items: [
            {
                path: '#Accounting Reports#',
                text: t('drawer-menu:AccountingReports'),
                icon: 'rowfield',
                prg: '',
                favorite: false,
                items: [
                    {
                        path: '/lx200084',
                        text: t('report200084:name.page'),
                        icon: 'doc',
                        prg: 'C_NO_MODULE_PUT_TO_ITEMSWITHOUTMENU_FOLDER',
                        favorite: false,
                    },
                ]
            },
            {
                path: '#Base Data Reports#',
                text: t('drawer-menu:BaseDataReports'),
                icon: 'rowfield',
                prg: '',
                favorite: false,
                items: [
                    {
                        path: '/lx200085',
                        text: t('report200085:name.page'),
                        icon: 'doc',
                        prg: 'C_NO_MODULE_PUT_TO_ITEMSWITHOUTMENU_FOLDER',
                        favorite: false,
                    },
                ]
            },
            {
                path: '#BackgroundProcesses#',
                text: t('drawer-menu:backgroundProcesses'),
                icon: 'flaticon flaticon-agreement',
                prg: '',
                favorite: true,
                items: [
                    {
                        path: '/jobs-page',
                        text: t('bg-jobs:name.page'),
                        icon: 'doc',
                        prg: 'C_NO_MODULE_PUT_TO_ITEMSWITHOUTMENU_FOLDER',
                        favorite: false,
                    },
                ]
            },
            {
                path: '/ixWebOwner',
                text: t('own:name.page'),
                icon: 'doc',
                prg: 'C_NO_MODULE_PUT_TO_ITEMSWITHOUTMENU_FOLDER',
                favorite: false,
            },
            {
                path: '/lx11725',
                text: t('process11725:name.page'),
                icon: 'doc',
                prg: 'C_NO_MODULE_PUT_TO_ITEMSWITHOUTMENU_FOLDER',
                favorite: false,
            },
            {
                path: '/ix2013',
                text: t('process2013:name.page'),
                icon: 'doc',
                prg: 'C_IX2013',
                favorite: false,
            },
            {
                path: '/ix2014',
                text: t('process2014:name.page'),
                icon: 'doc',
                prg: 'C_IX2014',
                favorite: false,
            },
            {
                path: '/lx2051',
                text: t('process2051:name.page'),
                icon: 'doc',
                prg: 'C_NO_MODULE_PUT_TO_ITEMSWITHOUTMENU_FOLDER',
                favorite: false,
            },
            {
                path: '/ixerechnungready',
                text: t('reportparerechnungready:name.page'),
                icon: 'doc',
                prg: 'C_NO_MODULE_PUT_TO_ITEMSWITHOUTMENU_FOLDER',
                favorite: false,
            },
            {
                path: '/MeldungVersFall',
                text: t('meldungVersFall:name.page'),
                icon: 'doc',
                prg: 'C_..\\NURIS\\NCREM.NURIS.MELDUNGVERSFALL',
                favorite: false,
            },
            {
                path: '/MeldungVersFallGwrk',
                text: t('meldungVersFallGwrk:name.page'),
                icon: 'doc',
                prg: 'C_..\\NURIS\\NCREM.NURIS.MELDUNGVERSFALLGWRK',
                favorite: false,
            },
            {
                path: '/ix2076',
                text: t('2076:name.page'),
                icon: 'doc',
                prg: 'C_IX2076',
                favorite: false,
            },
            {
                path: '/ix2000bi',
                text: t('2000bi:name.page'),
                icon: 'doc',
                prg: 'C_IX2000BI',
                favorite: false,
            },
            {
                path: '/ix20011',
                text: t('20011:name.page'),
                icon: 'doc',
                prg: 'C_IX20011',
                favorite: false,
            },
            {
                path: '/process-printer',
                text: t('Process Printer'),
                icon: 'doc',
                prg: '',
                favorite: false,
            },
        ]
    },
]

const prepareNav = (n: IIxNavData, parentPath: string = '') => {
    let path = n.qParams ? `${n.path}?${n.qParams}` : n.path
    if (n.path === '/inactive') {
        path = `${path}${n.qParams ? '&' : '?'}prg=${n.prg}`
    }
    const fullPath = parentPath ? `${parentPath}|${path}` : path
    const navItem: IIxNavItem = {
        path,
        text: n.text,
        icon: n.icon,
        favorite: n.favorite,
        prg: n.prg,
        fullPath,
    }

    if (n.items) {
        navItem.items = n.items.map(child => prepareNav(child, fullPath))
    }

    return navItem
}

const navItems: IIxNavItem[] = navTree.map(item => prepareNav(item, ''))


export {
    routes,
    titles,
    navItems,
}
